import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import { ConfirmDialogService, ToastService, useDataTable, useDataTableBasic } from '@iamsoftware/react-hooks';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputNumber } from 'primereact/inputnumber';
import { FileUpload } from 'primereact/fileupload';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { PdfCanvasViewer } from '../PdfCanvasViewer';
import { Divider } from 'primereact/divider';
import { Steps } from 'primereact/steps';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { AgreementService } from '../../../service/AgreementService';
import { DocumentSignService } from '../../../service/DocumentSignService';
import { DraftTab } from './components/tabs/DraftTab';
import { InProgressTab } from './components/tabs/InProgressTab';
import { CompletedTab } from './components/tabs/CompletedTab';
import { CancelledTab } from './components/tabs/CancelledTab';
import { TrashTab } from './components/tabs/TrashTab';
import { Oauth2GoogleService } from '../../hop-dong/mau-hop-dong/Oauth2GoogleService';

import { GoogleService } from '../GoogleService';
import { UploadExcel } from '../UploadExcel';
import { AgreementConfigService } from '../../../service/AgreementConfigService';
import { CommonService } from '../../../service/CommonService';
import { CustomerService } from '../../danh-muc/khach-hang/CustomerService';
import { useCustomerDialog } from '../../../hooks/useCustomerDialog';
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist';
import { Step1InfoAndFiles } from '../tai-lieu/components/Step1InfoAndFiles';
import { Step2Signers } from '../tai-lieu/components/Step2Signers';
import { Step3Positions } from '../tai-lieu/components/Step3Positions';
import { AgreementTemplateService } from '../../quan-ly-loai-tai-lieu/tai-lieu-mau/AgreementTemplateService';
import { TemplateSelectionDialog } from '../tai-lieu/components/TemplateSelectionDialog';
import { Menu } from 'primereact/menu';

GlobalWorkerOptions.workerSrc = '/pdfjs/pdf.worker.min.mjs';

// Helper function to extract file extension from fileName and contentType
const extractFileExtension = (fileName?: string, contentType?: string): string => {
  if (fileName && typeof fileName === 'string') {
    const parts = fileName.split('.');
    if (parts.length > 1) {
      const ext = parts[parts.length - 1].toLowerCase();
      if (ext && !/^\d+$/.test(ext)) {
        return ext;
      }
    }
  }

  if (contentType) {
    if (contentType.includes('wordprocessingml')) return 'docx';
    if (contentType.includes('pdf')) return 'pdf';
    if (contentType.includes('spreadsheetml')) return 'xlsx';
    if (contentType.includes('presentationml')) return 'pptx';
    if (contentType.includes('msword')) return 'doc';
    if (contentType.includes('excel')) return 'xls';
    if (contentType.includes('powerpoint')) return 'ppt';
  }

  return 'docx';
};

export const TaiLieuKy: React.FC = () => {
    const navigate = useNavigate();
    const toast = useRef<Toast>(null);
    const [headerResult, setHeaderResult] = useState<any>(null);
    const [agreementParties, setAgreementParties] = useState<any[]>([]);
    const [displaySignerDialog, setDisplaySignerDialog] = useState<any>(null);
    const [isSigning, setIsSigning] = useState(false);
    const [isBulkSigning, setIsBulkSigning] = useState(false);
    const [bulkSignProgress, setBulkSignProgress] = useState({ current: 0, total: 0 });
    const [cancelDialog, setCancelDialog] = useState<any>(null);
    const [cancelReason, setCancelReason] = useState<string>('');
    const [showFileViewer, setShowFileViewer] = useState(false);
    const [viewerUrl, setViewerUrl] = useState<string | null>(null);
    const [viewerFileName, setViewerFileName] = useState<string>('');
    const [displayEmailDialog, setDisplayEmailDialog] = useState<any>(null);
    const [emailParties, setEmailParties] = useState<any[]>([]);
    const [sendingEmail, setSendingEmail] = useState(false);
    const [displayUploadExcel, setDisplayUploadExcel] = useState(false);
    const [displayFileDialog, setDisplayFileDialog] = useState<any>(null);
    const [fileDialogMainFiles, setFileDialogMainFiles] = useState<any[]>([]);
    const [fileDialogAttachmentFiles, setFileDialogAttachmentFiles] = useState<any[]>([]);
    const [fileDialogActiveTabIndex, setFileDialogActiveTabIndex] = useState(0);
    const [fileDialogViewingAttachmentIndex, setFileDialogViewingAttachmentIndex] = useState<number | null>(null);
    const fileDialogOpenedFileIdsRef = useRef<Set<string>>(new Set());
    const [fileDialogMainFileReady, setFileDialogMainFileReady] = useState<{ [key: string]: boolean }>({});
    const [fileDialogAttachmentFileReady, setFileDialogAttachmentFileReady] = useState<{ [key: string]: boolean }>({});
    const fileDialogMainFileBlobUrlsRef = useRef<{ [key: string]: string }>({});
    const fileDialogAttachmentFileBlobUrlsRef = useRef<{ [key: string]: string }>({});
    const [fileDialogMainFileBlobUrls, setFileDialogMainFileBlobUrls] = useState<{ [key: string]: string }>({});
    const [fileDialogAttachmentFileBlobUrls, setFileDialogAttachmentFileBlobUrls] = useState<{ [key: string]: string }>({});
    const [displayUploadAttachmentDialog, setDisplayUploadAttachmentDialog] = useState<any>(null);
    const [uploadingAttachment, setUploadingAttachment] = useState(false);
    const fileUploadAttachmentRef = useRef<FileUpload>(null);
    const [uploadDialogDocumentTypeItems, setUploadDialogDocumentTypeItems] = useState<any[]>([]);
    const [uploadDialogDocumentTypeItemMeta, setUploadDialogDocumentTypeItemMeta] = useState<Record<string, { formType?: string | null; receivedDate?: Date | null }>>({});
    const [uploadDialogDocumentTypeItemsLoading, setUploadDialogDocumentTypeItemsLoading] = useState<boolean>(false);
    const [uploadDialogFileTypes, setUploadDialogFileTypes] = useState<any[]>([]);
    const [uploadDialogAttachedFiles, setUploadDialogAttachedFiles] = useState<any[]>([]);
    const [uploadDialogAgreementType, setUploadDialogAgreementType] = useState<string | null>(null);
    const [selectedFile, setSelectedFile] = useState<any>(null); // Added for PdfCanvasViewer

    // States for Bulk Upload Excel
    const [bulkTemplates, setBulkTemplates] = useState<any[]>([]);
    const [selectedBulkTemplateId, setSelectedBulkTemplateId] = useState<string | null>(null);
    const [isUploadingExcel, setIsUploadingExcel] = useState(false);
    const [displayBulkUploadDialog, setDisplayBulkUploadDialog] = useState(false);
    const [bulkExcelFile, setBulkFile] = useState<File | null>(null);
    const [bulkUploadResult, setBulkUploadResult] = useState<any[]>([]);
    const [displayBulkResultDialog, setDisplayBulkResultDialog] = useState(false);
    const excelInputRef = useRef<HTMLInputElement>(null);
    const [pdfGenerating, setPdfGenerating] = useState<Set<string>>(new Set());

    useEffect(() => {
        loadBulkTemplates();
    }, []);

    const loadBulkTemplates = () => {
        AgreementTemplateService.findAgreementList({ disabled: 'N' })
            .then((res: any) => {
                const list = res?.listData || res?.data || [];
                if (Array.isArray(list)) {
                    setBulkTemplates(list.map(t => ({
                        label: `${t.agreementPseudoId ? t.agreementPseudoId + ' - ' : ''}${t.agreementName}`,
                        value: t.agreementId
                    })));
                }
            })
            .catch(() => setBulkTemplates([]));
    };

    const handleExcelUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            setBulkFile(file);
        } else {
            ToastService.error('Chưa chọn file Excel');
        }
    };

    const handleSubmitBulkUpload = async () => {
        if (!selectedBulkTemplateId) {
            ToastService.error('Vui lòng chọn mẫu tài liệu');
            return;
        }
        if (!bulkExcelFile) {
            ToastService.error('Vui lòng chọn file Excel');
            return;
        }

        setIsUploadingExcel(true);
        try {
            const res = await AgreementService.bulkAgreementFromTemplate(bulkExcelFile, selectedBulkTemplateId);
            if (res?.success === 'Y') {
                ToastService.success(res?.message || 'Tải lên và xử lý file Excel thành công!');
                setBulkUploadResult(res?.resultList || []);
                setDisplayBulkResultDialog(true);
                setBulkFile(null);
                if (excelInputRef.current) excelInputRef.current.value = '';
                setDisplayBulkUploadDialog(false);
                reloadLazyData();
                handleTabChange({ index: 0 });
            } else {
                ToastService.error(res?.error || 'Có lỗi xảy ra khi xử lý file Excel');
            }
        } catch (error) {
            ToastService.error('Lỗi khi tải lên file Excel');
        } finally {
            setIsUploadingExcel(false);
        }
    };

    const handleDownloadTemplate = async () => {
        if (!selectedBulkTemplateId) {
            ToastService.error('Vui lòng chọn mẫu tài liệu để tải file mẫu');
            return;
        }
        const selectedTemplate = bulkTemplates.find(t => t.value === selectedBulkTemplateId);
        const templateName = selectedTemplate?.label || 'template';
        try {
            await AgreementService.downloadExcelTemplate(selectedBulkTemplateId, templateName);
        } catch (error) {
            ToastService.error('Lỗi khi tải file mẫu');
        }
    };

    const handleBulkSign = async (selectedItems?: any[]) => {
        if (!selectedItems || selectedItems.length === 0) {
            ToastService.error('Vui lòng chọn ít nhất một tài liệu để ký');
            return;
        }

        ConfirmDialogService.confirm(
            'Xác nhận ký hàng loạt',
            `Bạn có chắc chắn muốn ký hàng loạt ${selectedItems.length} tài liệu đã chọn?`,
            async () => {
                setIsBulkSigning(true);
                try {
                    await DocumentSignService.bulkSign(selectedItems);
                } catch (err) {
                    console.error('Lỗi khi ký hàng loạt:', err);
                }
                setIsBulkSigning(false);
                reloadLazyData();
            }
        );
    };
    const [currentPage, setCurrentPage] = useState(1); // Added for PdfCanvasViewer

    const resetCreateForm = (fromTemplate?: boolean) => {
        setCreateStep(0);
        setMaxStepReached(0);
        setValidationTriggered(false);
        setCreateFormData({
            agreementName: '',
            agreementNo: '',
            agreementNoInt: null,
            agreementNoFormatEnumId: null,
            agreementDate: null,
            agreementConfigureEnumId: null,
            agreementType: null,
            description: '',
            fromDate: null,
            thruDate: null,
            effectiveDate: null,
            expiryDate: null,
            isImportant: false,
            isUrgent: false
        });
        setMainFiles([]);
        setAttachedFiles([]);
        setDocumentRecipients([{
            _internalId: crypto.randomUUID(),
            party: null, partyId: '', taxCode: '', partyName: '', emailAddress: '',
            contactNumber: '', representativeName: '', identityCard: '', roleTypeId: ''
        }]);
        setSignaturePositions([]);
        setDocumentTypeItems([]);
        setDocumentTypeItemMeta({});
        setGoogleFileId('');
        setShowGDoc(false);
        setDisplayEditor(null);
        setActiveRecipientIndex(null);
        setPageCanvases([]);
        setFilePreviews({});
        setPreviewLoading({});

        if (!fromTemplate) {
            setSelectedTemplateData(null);
            setTemplateFormFields([]);
            setTemplateFieldValues({});
            setIsCreatingFromTemplate(false);
        }
    };

    const openCreateDialog = (fromTemplate?: boolean) => {
        if (!fromTemplate) {
            resetCreateForm(false);
        }
        setDisplayCreateDialog(true);
    };

    useEffect(() => {
        setHeaderResult(
            <div className="flex align-items-center">
                <span>Quản lý tài liệu</span>
            </div>
        );
    }, []);

    const [displayCreateDialog, setDisplayCreateDialog] = useState(false);
    const [creatingAgreement, setCreatingAgreement] = useState(false);
    const [createStep, setCreateStep] = useState(0);
    const [maxStepReached, setMaxStepReached] = useState(0);
    const [createFormData, setCreateFormData] = useState({
        agreementName: '',
        agreementNo: '',
        agreementNoInt: null as number | null,
        agreementNoFormatEnumId: null as string | null,
        agreementDate: null as Date | null,
        agreementConfigureEnumId: null as string | null,
        agreementType: null as string | null,
        description: '',
        fromDate: null as Date | null,
        thruDate: null as Date | null,
        effectiveDate: null as Date | null,
        expiryDate: null as Date | null,
        isImportant: false,
        isUrgent: false
    });
    const [agreementTypeOptions, setAgreementTypeOptions] = useState<any[]>([]);

    // State for Step 2 & 3 (Files, Signers, Positions)
    const [mainFiles, setMainFiles] = useState<any[]>([]);
    const [attachedFiles, setAttachedFiles] = useState<any[]>([]);
    const [documentRecipients, setDocumentRecipients] = useState<any[]>([{
        _internalId: crypto.randomUUID(),
        party: null, partyId: '', taxCode: '', partyName: '', emailAddress: '',
        contactNumber: '', representativeName: '', identityCard: '', roleTypeId: ''
    }]);
    const [signaturePositions, setSignaturePositions] = useState<any[]>([]);
    const [selectedSigner, setSelectedSigner] = useState<any>(null);
    const [documentTypeItems, setDocumentTypeItems] = useState<any[]>([]);
    const [documentTypeItemsLoading, setDocumentTypeItemsLoading] = useState(false);
    const [documentTypeItemMeta, setDocumentTypeItemMeta] = useState<Record<string, any>>({});
    const [fileTypes, setFileTypes] = useState<any[]>([]);
    const [roleOptions, setRoleOptions] = useState<any[]>([]);
    const [customers, setCustomers] = useState<any[]>([]);
    const [customerSuggestions, setCustomerSuggestions] = useState<any[]>([]);
    const [activeRecipientIndex, setActiveRecipientIndex] = useState<number | null>(null);
    const [canvasLoading, setCanvasLoading] = useState(false);
    const [selectedSignatureType, setSelectedSignatureType] = useState<string>('AgtDigitalVerified');
    const [pageCanvases, setPageCanvases] = useState<any[]>([]);
    const canvasRefs = useRef<any[]>([]);
    const draggableRefs = useRef<Record<string, React.RefObject<any>>>({});
    const [filePreviews, setFilePreviews] = useState<Record<string, string>>({});
    const [previewLoading, setPreviewLoading] = useState<Record<string, boolean>>({});
    const [googleFileId, setGoogleFileId] = useState<string>('');
    const [showGDoc, setShowGDoc] = useState<boolean>(false);
    const [displayEditor, setDisplayEditor] = useState<any>(null);
    const [validationTriggered, setValidationTriggered] = useState(false);
    const [activeMainFileIndex, setActiveMainFileIndex] = useState(0);

    // Template selection states
    const [showTemplateDialog, setShowTemplateDialog] = useState(false);
    const [templateFormFields, setTemplateFormFields] = useState<any[]>([]);
    const [selectedTemplateData, setSelectedTemplateData] = useState<any>(null);
    const [fillingTemplate, setFillingTemplate] = useState(false);
    const [isCreatingFromTemplate, setIsCreatingFromTemplate] = useState(false);
    const [templateFieldValues, setTemplateFieldValues] = useState<Record<string, any>>({});

    const hasTemplateFields = isCreatingFromTemplate && templateFormFields.length > 0;
    const createStepsItems = [
        ...(hasTemplateFields ? [{ label: 'Điền thông tin' }] : []),
        { label: 'Thông tin & Tệp' },
        { label: 'Người nhận' },
        { label: 'Vị trí ký' }
    ];
    // Offset cho các step gốc khi có step điền thông tin
    const stepOffset = hasTemplateFields ? 1 : 0;

    useEffect(() => {
        if (displayCreateDialog && agreementTypeOptions.length === 0) {
            CommonService.getAgreementType().then(res => {
                const source = Array.isArray(res) ? res : res?.list ?? res?.listData ?? [];
                if (Array.isArray(source) && source.length > 0) {
                    const sorted = [...source].sort((a, b) => (a.description || '').localeCompare(b.description || ''));
                    setAgreementTypeOptions(sorted.map((it: any) => ({
                        ...it,
                        label: it.agreementConfigureName || it.agreementTypeName || it.description || it.label || it.enumId || it.value || '',
                        value: it.agreementConfigureEnumId || it.agreementTypeId || it.enumId || it.value || ''
                    })));
                }
            });
        }
    }, [displayCreateDialog]);

    useEffect(() => {
        const typeId = createFormData.agreementType || createFormData.agreementConfigureEnumId;
        if (!typeId) {
            setDocumentTypeItems([]);
            return;
        }

        const selectedType = agreementTypeOptions.find((item: any) => item.value === typeId);
        if (!selectedType) {
            setDocumentTypeItems([]);
            return;
        }

        const configId =
            selectedType.agreementPartyTypeConfId ||
            selectedType.agreementTypeConfId ||
            selectedType.id ||
            selectedType.value;

        if (!configId) {
            setDocumentTypeItems([]);
            return;
        }

        let ignore = false;
        setDocumentTypeItemsLoading(true);

        // Clear existing attachments and metadata when config changes
        setDocumentTypeItemMeta({});
        setAttachedFiles([]);
        
        AgreementConfigService.get(String(configId))
            .then(res => {
                if (ignore) return;
                if (res?.success === 'Y') {
                    setDocumentTypeItems(res.items || []);
                } else {
                    setDocumentTypeItems([]);
                }
            })
            .catch(() => {
                if (!ignore) setDocumentTypeItems([]);
            })
            .finally(() => {
                if (!ignore) setDocumentTypeItemsLoading(false);
            });

        return () => { ignore = true; };
    }, [createFormData.agreementType, createFormData.agreementConfigureEnumId]);

    // Load file types immediately to ensure formTypeOptions are populated
    useEffect(() => {
        let ignore = false;
        CommonService.getFileTypes().then(res => {
            if (ignore) return;
            const list = res?.listData || res?.list || res || [];
            setFileTypes(list);
        });
        return () => { ignore = true; };
    }, []);

    const formTypeOptions = useMemo(() => {
        if (Array.isArray(fileTypes) && fileTypes.length > 0) {
            return fileTypes.map((ft: any) => ({
                label: String(ft.description || ft.enumName || ft.enumId || ''),
                value: String(ft.enumId || ft.value || ft.enumCode || ''),
                enumCode: ft.enumCode ? String(ft.enumCode) : String(ft.enumId || ''),
                raw: ft
            }));
        }
    }, [fileTypes]);

    const handleInputChange = (field: string, value: any) => {
        setCreateFormData(prev => ({ ...prev, [field]: value }));
    };

    const formatSeq = (n: number) => (n < 10 ? `0${n}` : String(n));
    const normalizeLocationSeq = (positions: any[]) =>
        positions.map((pos, idx) => ({ ...pos, locationSeqId: formatSeq(idx + 1) }));

    const resolveConfigItemSeq = (item: any, idx: number) => {
        if (!item) return null;
        const s = item.agreementItemSeq ?? item.configSequenceNum ?? item.sequenceNum;
        if (s !== null && typeof s !== 'undefined') return Number(s);
        return idx + 1;
    };

    const normalizeFormTypeValue = (val: any) => {
        if (!val) return null;
        if (typeof val === 'object' && val.value) return val.value;
        return val;
    };

    const getIconByExtension = (ext: string) => {
        switch (ext?.toLowerCase()) {
            case 'pdf': return { icon: 'pi pi-file-pdf', color: 'text-red-500' };
            case 'docx':
            case 'doc': return { icon: 'pi pi-file-word', color: 'text-blue-500' };
            case 'xlsx':
            case 'xls': return { icon: 'pi pi-file-excel', color: 'text-green-500' };
            default: return { icon: 'pi pi-file', color: 'text-gray-500' };
        }
    };

    const getFileTypeName = (item: any): string => {
        if (!item) return 'Không có mô tả';
        const fileTypeId = item.fileTypeEnumId || item.fileTypeId;
        if (!fileTypeId || fileTypes.length === 0) return item.description || 'Không có mô tả';
        const fileType = fileTypes.find((ft: any) => ft.enumId === fileTypeId || ft.enumCode === fileTypeId);
        return fileType?.description || item.description || 'Không có mô tả';
    };

    const extractFileExtension = (fileName: string, contentType?: string) => {
        if (fileName.includes('.')) return fileName.split('.').pop()?.toLowerCase() || '';
        if (contentType === 'application/pdf') return 'pdf';
        if (contentType?.includes('word')) return 'docx';
        return '';
    };

    const getFileExtension = (filename: string) => {
        return filename.split('.').pop()?.toLowerCase() || '';
    };

    const handleDownloadFile = async (file: any) => {
        try {
            console.log('>>> handleDownloadFile (DanhSach - Hybrid Storage):', file);
            const fileId = extractOriginalFileId(file);
            if (!fileId) {
                ToastService.error('Không tìm thấy ID file để tải');
                return;
            }

            const blob = await Oauth2GoogleService.getMedia(fileId);
            const fileName = (file.name || file.fileName || 'document').replace(/\.[^/.]+$/, "");
            const extension = extractFileExtension(file.name || file.fileName, file.contentType) || 'docx';

            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${fileName}.${extension}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            ToastService.success('Đã tải file thành công');
        } catch (e) {
            console.error('>>> Download error:', e);
            ToastService.error('Không thể tải xuống file này');
        }
    };

    const handleRemoveLocalFile = (file: any) => {
        const targetId = file.fileId || file.googleFileId || file.id || null;
        const matchFile = (candidate: any) => {
            const candidateId = candidate.fileId || candidate.googleFileId || candidate.id || null;
            return targetId && candidateId && targetId === candidateId;
        };

        if (file.isMainFile) {
            setMainFiles(prev => prev.filter(f => !matchFile(f)));
        } else {
            setAttachedFiles(prev => prev.filter(f => !matchFile(f)));
        }
    };

    const getFileMenuItems = (file: any) => {
        const fileId = file.fileId || file.googleFileId || file.id;
        const isGenerating = pdfGenerating.has(fileId);
        
        const items = [
            {
                label: isGenerating ? 'Đang chuẩn bị...' : 'Xem',
                icon: isGenerating ? 'pi pi-spin pi-spinner' : 'pi pi-eye',
                command: (e: any) => {
                    e?.originalEvent?.stopPropagation?.();
                    if (isGenerating) {
                        ToastService.error('Bản xem trước đang được xử lý, vui lòng đợi xíu nha!');
                        return;
                    }
                    handleViewFile(file);
                },
                disabled: isGenerating
            },
            {
                label: 'Chỉnh sửa',
                icon: 'pi pi-pencil',
                command: (e: any) => {
                    e?.originalEvent?.stopPropagation?.();
                    handleEditFile(file);
                },
                disabled: file.extension === 'pdf'
            },
            {
                label: 'Tải xuống',
                icon: 'pi pi-download',
                command: (e: any) => {
                    e?.originalEvent?.stopPropagation?.();
                    handleDownloadFile(file);
                }
            },
            {
                separator: true
            },
            {
                label: 'Xóa',
                icon: 'pi pi-trash',
                command: (e: any) => {
                    e?.originalEvent?.stopPropagation?.();
                    handleRemoveLocalFile(file);
                },
                template: (item: any, options: any) => {
                    return (
                        <button 
                            onClick={(e) => options.onClick(e)} 
                            className="p-menuitem-link appearance-none border-none bg-transparent w-full text-left flex align-items-center gap-2 px-3 py-2" 
                            style={{ cursor: 'pointer', transition: 'background-color 0.2s' }}
                            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'var(--surface-hover)')}
                            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                        >
                            <span className={`p-menuitem-icon ${item.icon} text-red-500`}></span>
                            <span className="p-menuitem-text text-red-500 font-medium">{item.label}</span>
                        </button>
                    )
                }
            }
        ];
        return items;
    };

    const getAttachmentMenuItems = (file: any, onRemove?: (f: any) => void) => {
        const fileId = file.fileId || file.googleFileId || file.id;
        const isGenerating = pdfGenerating.has(fileId);
        
        const items = [
            {
                label: isGenerating ? 'Đang chuẩn bị...' : 'Xem',
                icon: isGenerating ? 'pi pi-spin pi-spinner' : 'pi pi-eye',
                command: (e: any) => {
                    e?.originalEvent?.stopPropagation?.();
                    if (isGenerating) {
                        ToastService.error('Bản xem trước đang được xử lý, vui lòng đợi xíu nha!');
                        return;
                    }
                    handleViewFile(file);
                },
                disabled: isGenerating
            },
            {
                label: 'Tải xuống',
                icon: 'pi pi-download',
                command: (e: any) => {
                    e?.originalEvent?.stopPropagation?.();
                    handleDownloadFile(file);
                }
            },
            {
                separator: true
            },
            {
                label: 'Xóa',
                icon: 'pi pi-trash',
                command: (e: any) => {
                    e?.originalEvent?.stopPropagation?.();
                    if (onRemove) {
                        onRemove(file);
                    } else {
                        handleRemoveLocalFile(file);
                    }
                },
                template: (item: any, options: any) => {
                    return (
                        <button 
                            onClick={(e) => options.onClick(e)} 
                            className="p-menuitem-link appearance-none border-none bg-transparent w-full text-left flex align-items-center gap-2 px-3 py-2" 
                            style={{ cursor: 'pointer', transition: 'background-color 0.2s' }}
                            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'var(--surface-hover)')}
                            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                        >
                            <span className={`p-menuitem-icon ${item.icon} text-red-500`}></span>
                            <span className="p-menuitem-text text-red-500 font-medium">{item.label}</span>
                        </button>
                    )
                }
            }
        ];
        return items;
    };

    const handleViewFile = async (f: any) => {
        console.log('>>> handleViewFile click (Tạo mới):', f);
        const fileId = f.fileId || f.googleFileId || f.id;
        if (pdfGenerating.has(fileId)) {
            ToastService.error('Bản xem trước đang được xử lý, vui lòng đợi xíu nha!');
            return;
        }

        let targetId = extractViewFileId(f);
        if (!targetId) {
            try {
                ToastService.error('Đang chuẩn bị bản xem trước, vui lòng đợi ít giây...');
                const res = await AgreementService.generatePdf(fileId, f.name || f.fileName, f.contentType, f.agreementContentId);
                if (res && (res.referenceFileId)) {
                    targetId = res.referenceFileId;
                }
            } catch (err) {
                console.error('Lỗi khi chuẩn bị file PDF:', err);
            }
        }

        if (!targetId) {
            ToastService.error('Bản xem trước chưa sẵn sàng, vui lòng thử lại sau ít phút!');
            return;
        }
        setSelectedFile(f);
        setViewerUrl(targetId);
        setViewerFileName(f.name || f.fileName || '');
        setCurrentPage(1);
        setShowFileViewer(true);
    };

    const handleEditFile = async (file: any) => {
        const fileId = extractOriginalFileId(file);
        if (!fileId) {
            console.error('>>> handleEditFile error: No fileId found for', file);
            ToastService.error('File này không thể chỉnh sửa');
            return;
        }
        try {
            console.log('>>> Calling openEditor with fileId:', fileId);
            const result = await AgreementService.openEditor(null, fileId);
            console.log('>>> openEditor result:', result);

            if (result && result.googleFileId) {
                setDisplayEditor({ 
                    fileId: result.googleFileId, 
                    originalFileId: fileId,
                    fileName: file.name || file.fileName || 'Chỉnh sửa tài liệu' 
                });
            } else {
                ToastService.error(result?.error || 'Không thể mở quyền chỉnh sửa');
            }
        } catch (error) {
            ToastService.error('Có lỗi xảy ra khi mở chỉnh sửa');
        }
    };

    const handleDocumentTypeItemUpload = (item: any, idx: number) => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.pdf,.docx,.doc';
        input.onchange = (e: any) => {
            const file = e.target.files?.[0];
            if (file) {
                const seq = item.sequenceNum || item.configSequenceNum || (idx + 1);
                const tempId = `temp-${Date.now()}`;
                
                // Hiển thị placeholder ngay lập tức
                const placeholder = {
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    fileId: tempId,
                    id: tempId,
                    isMainFile: false,
                    sequenceNum: seq,
                    uploading: true,
                    extension: file.name.split('.').pop()?.toLowerCase(),
                    contentType: file.type
                };

                setAttachedFiles(prev => {
                    const filtered = prev.filter(af => Number(af.sequenceNum || af.configSequenceNum) !== Number(seq));
                    return [...filtered, placeholder];
                });

                AgreementService.uploadFile(file)
                    .then(res => {
                        if (res && (res.success === 'Y' || res.fileId)) {
                            const mapped = {
                                name: res.fileName || file.name, 
                                googleFileId: res.fileId, 
                                fileId: res.fileId,
                                id: res.fileId,
                                sequenceNum: seq, 
                                isMainFile: false,
                                referenceFileId: res.referenceFileId,
                                contentType: extractFileExtension(res.fileName || file.name, res.contentType || file.type),
                                extension: res.format || file.name.split('.').pop()?.toLowerCase(),
                            };
                            
                            setAttachedFiles(prev => prev.map(f => f.fileId === tempId ? mapped : f));

                            // Gọi Async tạo PDF nếu chưa có referenceFileId
                            const ext = extractFileExtension(mapped.name, mapped.contentType);
                            if (ext !== 'pdf' && !mapped.referenceFileId) {
                                setPdfGenerating(prev => new Set(prev).add(res.fileId));
                                AgreementService.generatePdf(res.fileId, mapped.name, mapped.contentType)
                                    .then(pdfRes => {
                                        if (pdfRes?.referenceFileId) {
                                            setAttachedFiles(prev => prev.map(f => f.fileId === res.fileId ? { ...f, referenceFileId: pdfRes.referenceFileId } : f));
                                        }
                                    })
                                    .finally(() => {
                                        setPdfGenerating(prev => {
                                            const next = new Set(prev);
                                            next.delete(res.fileId);
                                            return next;
                                        });
                                    });
                            }
                        }
                    })
                    .catch(err => {
                        ToastService.error('Lỗi khi tải tệp lên');
                        setAttachedFiles(prev => prev.filter(f => f.fileId !== tempId));
                    });
            }
        };
        input.click();
    };

    const handleDocumentTypeItemMetaChange = (seq: string, field: string, val: any) => {
        setDocumentTypeItemMeta(prev => ({ ...prev, [seq]: { ...prev[seq], [field]: val } }));
    };

    const formatDateForAPI = (date: Date | null) => {
        if (!date) return undefined;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        const seconds = String(d.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    };

    const isSignerRole = (roleTypeId: any) => {
        const signerIds = roleOptions
            .filter((it: any) => {
                const desc = String(it?.label || '').toLowerCase();
                return /ký|sign/.test(desc) || /bên\s*[ab]/.test(desc);
            })
            .map((it: any) => it.value);
        return signerIds.includes(roleTypeId);
    };

    const addRecipient = () => {
        setDocumentRecipients(prev => [...prev, {
            _internalId: crypto.randomUUID(),
            party: null,
            partyId: '',
            taxCode: '',
            partyName: '',
            emailAddress: '',
            contactNumber: '',
            representativeName: '',
            identityCard: '',
            roleTypeId: ''
        }]);
    };

    const removeRecipient = (idx: number) => {
        setDocumentRecipients(prev => prev.filter((_, i) => i !== idx));
    };

    const handleRecipientChange = async (idx: number, field: string, value: any) => {
        let currentData = [...documentRecipients];
        const oldPartyId = currentData[idx]?.party?.partyId || currentData[idx]?.party?.value || currentData[idx]?.partyId;
        const recipientInternalId = currentData[idx]?._internalId;

        currentData[idx] = { ...currentData[idx], [field]: value };
        
        if (field === 'party') {
            const partyId = value?.partyId || value?.value || null;
            currentData[idx].partyId = partyId;
            setDocumentRecipients(currentData);
            
            // Xóa vị trí ký của đối tượng cũ khi thay đổi đối tượng
            if (oldPartyId && String(oldPartyId) !== String(partyId || '')) {
                setSignaturePositions(prev =>
                    normalizeLocationSeq(prev.filter(pos => {
                        // Xóa theo internalRecipientId (chính xác nhất)
                        if (pos.internalRecipientId && pos.internalRecipientId === recipientInternalId) {
                            return false;
                        }
                        // Xóa theo partyId cũ nếu không có internalRecipientId
                        if (!pos.internalRecipientId && pos.partyId && String(pos.partyId) === String(oldPartyId)) {
                            return false;
                        }
                        return true;
                    }))
                );
            }

            if (partyId) {
                try {
                    const customer = await CustomerService.get(partyId);
                    setDocumentRecipients(prev => {
                        const newData = [...prev];
                        newData[idx] = { ...newData[idx] };
                        newData[idx].taxCode = customer.partyTaxId || '';
                        newData[idx].partyName = customer.partyName || '';
                        newData[idx].emailAddress = customer.emailAddress || '';
                        newData[idx].contactNumber = customer.contactNumber || '';
                        newData[idx].representativeName = customer.representativeName || '';
                        newData[idx].identityCard = customer.idValue || '';
                        return newData;
                    });
                } catch (e) {}
            }
        } else {
            setDocumentRecipients(currentData);
        }
    };

    const searchCustomers = (event: any) => {
        CustomerService.find(event.query || '').then((data: any) => {
            if (data?.listData) {
                setCustomerSuggestions(data.listData.map((item: any) => ({
                    ...item,
                    value: item.partyId,
                    label: `[${item.pseudoId}] - ${item.partyName}`
                })));
            } else {
                setCustomerSuggestions([...customers]);
            }
        }).catch(() => {
            setCustomerSuggestions([...customers]);
        });
    };

    const customerDialog = useCustomerDialog({
        service: CustomerService,
        requireTaxCode: true,
        async onAfterCreate(resp: any) {
            const customerData = await CustomerService.find('');
            const newCustomers = (customerData.listData || []).map((customer: any) => ({
                ...customer,
                value: customer.partyId,
                label: `[${customer.pseudoId}] - ${customer.partyName}`
            }));
            setCustomers(newCustomers);
            const newCustomer = newCustomers.find((customer: any) => customer.partyId === resp.partyId);
            if (newCustomer && activeRecipientIndex !== null) {
                await handleRecipientChange(activeRecipientIndex, 'party', {
                    value: newCustomer.partyId,
                    partyId: newCustomer.partyId,
                    label: newCustomer.label
                });
            }
        }
    });

    const createCustomer = (idx: number) => {
        console.log('>>> createCustomer click idx:', idx);
        setActiveRecipientIndex(idx);
        const rec = documentRecipients[idx];
        console.log('>>> current data for pre-fill:', rec);
        customerDialog.create({
            partyTypeEnumId: rec.taxCode ? 'PtyOrganization' : 'PtyPerson',
            partyName: rec.partyName,
            partyTaxId: rec.taxCode,
            emailAddress: rec.emailAddress,
            contactNumber: rec.contactNumber,
            representativeName: rec.representativeName,
            idValue: rec.identityCard
        });
    };

    const handleComputerUpload = (isMainFile: boolean = true, configItemIdx?: number) => {
        if (!isMainFile && configItemIdx !== undefined) {
             const items = documentTypeItems || [];
             handleDocumentTypeItemUpload(items[configItemIdx], configItemIdx);
             return;
        }

        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.pdf,.docx,.doc';
        input.multiple = true;
        input.onchange = (e: any) => {
            const files = e.target.files;
            if (files && files.length > 0) {
                const fileList = Array.from(files);
                
                fileList.forEach((file: any) => {
                    const tempId = `temp-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

                    // Hiển thị placeholder ngay lập tức
                    const placeholder = {
                        name: file.name,
                        size: file.size,
                        type: file.type,
                        fileId: tempId,
                        id: tempId,
                        isMainFile: true,
                        uploading: true,
                        extension: file.name.split('.').pop()?.toLowerCase(),
                        contentType: extractFileExtension(file.name, file.type)
                    };
                    setMainFiles(prev => [...prev, placeholder]);

                    AgreementService.uploadFile(file)
                        .then(res => {
                            if (res && (res.success === 'Y' || res.fileId)) {
                                const mapped = {
                                    name: res.fileName || file.name,
                                    size: file.size,
                                    type: file.type,
                                    extension: res.format || file.name.split('.').pop()?.toLowerCase(),
                                    googleFileId: res.fileId,
                                    referenceFileId: res.referenceFileId,
                                    fileId: res.fileId,
                                    id: res.fileId,
                                    isMainFile: true,
                                    contentType: extractFileExtension(res.fileName || file.name, res.contentType || file.type)
                                };
                                setMainFiles(prev => prev.map(f => f.fileId === tempId ? mapped : f));

                                // Gọi Async tạo PDF nếu chưa có referenceFileId
                                if (mapped.extension !== 'pdf' && !mapped.referenceFileId) {
                                    setPdfGenerating(prev => new Set(prev).add(res.fileId));
                                    AgreementService.generatePdf(res.fileId, mapped.name, mapped.contentType)
                                        .then(pdfRes => {
                                            if (pdfRes?.referenceFileId) {
                                                setMainFiles(prev => prev.map(f => f.fileId === res.fileId ? { ...f, referenceFileId: pdfRes.referenceFileId } : f));
                                            }
                                        })
                                        .finally(() => {
                                            setPdfGenerating(prev => {
                                                const next = new Set(prev);
                                                next.delete(res.fileId);
                                                return next;
                                            });
                                        });
                                }
                            }
                        })
                        .catch(err => {
                            ToastService.error(`Lỗi khi tải tệp ${file.name} lên: ` + (err?.message || 'Lỗi không xác định'));
                            setMainFiles(prev => prev.filter(f => f.fileId !== tempId));
                        });
                });
            }
        };
        input.click();
    };


    const generateThumbnail = async (fileId: string, fileName: string, fallbackId: string) => {
        const fileKey = `${fileName}-${fallbackId}`;
        if (filePreviews[fileKey] || previewLoading[fileKey]) return;

        console.log(`[Thumbnail] Đang khởi tạo preview cho: ${fileName} (fileId: ${fileId})`);
        setPreviewLoading(prev => ({ ...prev, [fileKey]: true }));
        try {
            const pdfBlob = await AgreementService.downloadPdf(fileId);
            console.log(`[Thumbnail] Đã tải xong PDF cho: ${fileName}`);
            const arrayBuffer = await pdfBlob.arrayBuffer();
            const loadingTask = getDocument({ data: arrayBuffer });
            const pdf = await loadingTask.promise;
            const page = await pdf.getPage(1);
            
            const viewport = page.getViewport({ scale: 0.5 });
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            if (context) {
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                await page.render({ canvasContext: context, viewport }).promise;
                const dataUrl = canvas.toDataURL();
                setFilePreviews(prev => ({ ...prev, [fileKey]: dataUrl }));
                console.log(`[Thumbnail] Đã tạo xong ảnh preview cho: ${fileName}`);
            }
        } catch (error: any) {
            console.error(`[Thumbnail] Lỗi tạo preview cho ${fileName}:`, error);
        } finally {
            setPreviewLoading(prev => ({ ...prev, [fileKey]: false }));
        }
    };

    useEffect(() => {
        mainFiles.forEach(file => {
            const ext = (file.extension || '').toLowerCase();
            // Với PDF gốc, source chính là nó. Với Word, source là referenceFileId (PDF đã convert)
            const sourceId = file.referenceFileId || (ext === 'pdf' ? (file.fileId || file.googleFileId || file.id) : null);
            
            if (sourceId && !file.uploading) {
                const fallbackId = file.googleFileId || file.fileId || file.id;
                const fileKey = `${file.name}-${fallbackId}`;
                if (!filePreviews[fileKey] && !previewLoading[fileKey]) {
                    generateThumbnail(sourceId, file.name, fallbackId);
                }
            }
        });
    }, [mainFiles]);




    const handleCreateGoogleFile = async () => {

        try {
            const res = await Oauth2GoogleService.create({ fileName: createFormData.agreementName || 'Tài liệu mới' });
            if (res && res.fileId) {
                setGoogleFileId(res.fileId);
                setShowGDoc(true);
                setDisplayEditor({ 
                    fileId: res.fileId, 
                    fileName: res.fileName || createFormData.agreementName || 'Tài liệu mới',
                    contentType: 'application/vnd.google-apps.document'
                });
            }
        } catch (err) {
            ToastService.error('Không thể tạo file Google Doc');
        }
    };

    // --- Template selection handlers ---
    const handleTemplateSelected = (template: any) => {
        setShowTemplateDialog(false);
        resetCreateForm(true); 
        setIsCreatingFromTemplate(true);
        
        const tempId = `temp-template-${Date.now()}`;
        setMainFiles([{
            name: template.agreementName || 'Tài liệu từ mẫu',
            fileId: tempId,
            id: tempId,
            isMainFile: true,
            uploading: true,
            extension: 'docx'
        }]);

        let templateDetail: any = null;

        AgreementTemplateService.get(template.agreementId)
            .then(detail => {
                templateDetail = detail;
                setSelectedTemplateData(detail);
                if (detail.agreementConfigureEnumId) {
                    setCreateFormData(prev => ({
                        ...prev,
                        agreementType: detail.agreementConfigureEnumId,
                        agreementConfigureEnumId: detail.agreementConfigureEnumId
                    }));

                    AgreementService.generateDocumentCode(detail.agreementConfigureEnumId)
                        .then(res => {
                            if (res && res.agreementNo) {
                                setCreateFormData(prev => ({
                                    ...prev,
                                    agreementNo: res.agreementNo,
                                    agreementNoInt: res.agreementNoInt || null,
                                    agreementNoFormatEnumId: res.agreementNoFormatEnumId || null,
                                }));
                            }
                        })
                        .catch(err => console.error('Error generating document code', err));
                }

                return AgreementTemplateService.getFormFields(template.agreementId);
            })
            .then(fieldsRes => {
                const fields = fieldsRes?.dbFormFields || fieldsRes?.listData || [];
                const finalFields = Array.isArray(fields) ? fields : [];
                setTemplateFormFields(finalFields);

                const initial: Record<string, any> = {};
                finalFields.forEach((f: any) => initial[f.fieldName] = '');
                setTemplateFieldValues(initial);

                if (finalFields.length === 0) {
                    setFillingTemplate(true);
                    return AgreementService.fillPlaceholder({
                        templateAgreementId: template.agreementId,
                        placeholders: {}
                    }).then(res => {
                        const newFileId = res?.contentLocation || res?.googleFileId;
                        applyTemplateData(templateDetail, newFileId);
                        return res;
                    });
                } else {
                    applyTemplateData(templateDetail, null);
                }
                return null;
            })
            .then(res => {
                if (res) {
                    const mapped = {
                        name: res.fileName || template.agreementName || 'Tài liệu từ mẫu',
                        extension: res.format || 'docx',
                        googleFileId: res.fileId,
                        fileId: res.fileId,
                        id: res.fileId,
                        contentLocation: res.contentLocation,
                        referenceFileId: res.referenceFileId,
                        isMainFile: true,
                        contentType: res.contentType
                    };
                    setMainFiles([mapped]);
                    
                    if (mapped.extension !== 'pdf' && !mapped.referenceFileId) {
                        setPdfGenerating(prev => new Set(prev).add(res.fileId));
                        AgreementService.generatePdf(res.fileId, mapped.name, mapped.contentType)
                            .then(pdfRes => {
                                if (pdfRes?.referenceFileId) {
                                    setMainFiles(prev => prev.map(f => f.fileId === res.fileId ? { ...f, referenceFileId: pdfRes.referenceFileId } : f));
                                }
                            })
                            .finally(() => {
                                setPdfGenerating(prev => {
                                    const next = new Set(prev);
                                    next.delete(res.fileId);
                                    return next;
                                });
                            });
                    }
                }
                openCreateDialog(true);
            })
            .catch(err => {
                console.error('Error handling template selection', err);
                ToastService.error('Có lỗi xảy ra khi tải thông tin mẫu');
                setMainFiles([]);
            })
            .finally(() => setFillingTemplate(false));
    };

    const applyTemplateData = (detail: any, fileId?: string | null) => {
        // 1. Set main file
        const templateFileId = fileId || detail.fileId || detail.googleFileId;
        if (templateFileId) {
            const fileName = detail.fileName || 'Tài liệu từ mẫu';
            const contentType = detail.contentType || 'application/vnd.google-apps.document';
            const extension = extractFileExtension(fileName, contentType);
            
            setMainFiles([{
                name: fileName,
                googleFileId: templateFileId,
                fileId: templateFileId,
                id: templateFileId,
                googleFileUrl: `https://docs.google.com/document/d/${templateFileId}/edit`,
                type: contentType,
                extension: extension,
                isMainFile: true
            }]);
        }

        // 1.5 Set attachment files
        const attFiles = detail.attachmentFiles || [];
        if (Array.isArray(attFiles) && attFiles.length > 0) {
            const realFiles = attFiles.filter((att: any) => att.fileId || att.googleFileId || att.contentLocation);
            setAttachedFiles(realFiles.map((att: any) => ({
                name: att.fileName || att.description || 'Tệp đính kèm',
                fileId: att.fileId || att.googleFileId,
                id: att.fileId || att.googleFileId,
                contentType: att.contentType,
                sequenceNum: att.sequenceNum,
                isMainFile: false
            })));
        }

        // 2. Set recipients & roleOptions từ roles của mẫu
        const roles = detail.roles || [];
        const recipients = Array.isArray(roles) ? roles.map((role: any) => ({
            _internalId: crypto.randomUUID(),
            party: null,
            partyId: '',
            taxCode: '',
            partyName: '',
            emailAddress: '',
            contactNumber: '',
            representativeName: '',
            identityCard: '',
            roleTypeId: role.roleTypeId || ''
        })) : [];

        if (recipients.length > 0) {
            setDocumentRecipients(recipients);

            // Set roleOptions từ cấu hình mẫu
            setRoleOptions(prev => {
                const existing = new Set(prev.map(r => r.value));
                const newRoles = roles
                    .filter((r: any) => r.roleTypeId && !existing.has(r.roleTypeId))
                    .map((r: any) => ({ value: r.roleTypeId, label: r.description || r.roleTypeId }));
                return [...prev, ...newRoles];
            });
        }

        // 3. Set signature positions từ mẫu
        const positions = detail.signaturePositions || [];
        if (Array.isArray(positions) && positions.length > 0) {
            const mapped = positions.map((pos: any, idx: number) => {
                // Tìm role description cho label
                const role = roles.find((r: any) => r.roleTypeId === pos.roleTypeId);
                const label = role?.description || pos.partyName || pos.roleTypeId || '';

                // Tìm recipient tương ứng đã tạo ở trên để lấy _internalId
                const recipient = recipients.find((r: any) => r.roleTypeId === pos.roleTypeId);

                return {
                    locationSeqId: pos.locationSeqId || formatSeq(idx + 1),
                    internalRecipientId: recipient?._internalId,
                    x: Number(pos.ulx ?? pos.llx ?? pos.x ?? 0),
                    y: Number(pos.uly ?? pos.lly ?? pos.y ?? 0),
                    pageIndex: pos.pageIndex !== undefined && pos.pageIndex !== null ? Number(pos.pageIndex) : (Number(pos.pageNumber ?? 1) - 1),
                    widthPx: Number(pos.widthPx ?? 200),
                    heightPx: Number(pos.heightPx ?? 65),
                    fontSize: Number(pos.fontSize ?? 12),
                    signatureTypeEnumId: pos.signatureTypeEnumId || 'AgtDigitalVerified',
                    roleTypeId: pos.roleTypeId || '',
                    partyName: label,
                    label: label,
                    fileId: templateFileId
                };
            });
            setSignaturePositions(normalizeLocationSeq(mapped));
        }

        // 4. Load trực tiếp cấu hình phụ lục từ ConfId theo yêu cầu
        const configId = detail.agreementPartyTypeConfId || detail.agreementConfigureEnumId;
        if (configId) {
            setDocumentTypeItemsLoading(true);
            AgreementConfigService.get(String(configId))
                .then(res => {
                    if (res?.success === 'Y') {
                        setDocumentTypeItems(res.items || []);
                    } else {
                        setDocumentTypeItems([]);
                    }
                })
                .catch(() => {
                    setDocumentTypeItems([]);
                })
                .finally(() => {
                    setDocumentTypeItemsLoading(false);
                });
        } else {
            setDocumentTypeItems([]);
        }
    };

    const handleFillTemplateConfirm = async () => {
        if (!selectedTemplateData) return false;

        // Validation các trường bắt buộc
        if (Array.isArray(templateFormFields)) {
            const missingFields = templateFormFields
                .filter((f: any) => f.isRequired === 'Y' || f.isRequired === true)
                .filter((f: any) => {
                    const val = templateFieldValues[f.fieldName];
                    return val === undefined || val === null || (typeof val === 'string' && val.trim() === '');
                });

            if (missingFields.length > 0) {
                const names = missingFields.map((f: any) => f.title || f.fieldName).join(', ');
                ToastService.error(`Vui lòng nhập các trường bắt buộc: ${names}`);
                return false;
            }
        }

        setFillingTemplate(true);
        try {
            // Gọi API fill placeholder
            const res = await AgreementService.fillPlaceholder({
                templateAgreementId: selectedTemplateData.agreementId,
                placeholders: templateFieldValues
            });

            const newFileId = res?.contentLocation || res?.fileId || res?.googleFileId;
            if (newFileId) {
                setMainFiles([{
                    name: selectedTemplateData.fileName || 'Tài liệu từ mẫu',
                    googleFileId: res?.googleFileId || newFileId,
                    fileId: newFileId,
                    id: newFileId,
                    referenceFileId: res?.referenceFileId,
                    contentLocation: res?.contentLocation,
                    type: selectedTemplateData.contentType || 'application/vnd.google-apps.document',
                    extension: selectedTemplateData.format || 'docx',
                    isMainFile: true
                }]);

                // Tự động mapping người ký (Resolved Roles)
                let updatedRecipients = [...documentRecipients];
                if (Array.isArray(res.resolvedRoles) && res.resolvedRoles.length > 0) {
                    console.log('--- DBG: resolvedRoles from Backend:', res.resolvedRoles);
                    const resolvedRolesWithDetail = await Promise.all(res.resolvedRoles.map(async (r: any) => {
                        if (r.partyId) {
                            try {
                                const detail = await CustomerService.get(r.partyId);
                                console.log(`--- DBG: Detail for party ${r.partyId}:`, detail);
                                // Merge thông tin từ API detail, ưu tiên dữ liệu từ r để bảo toàn roleTypeId của template
                                return { ...detail, ...r };
                            } catch (e) {
                                console.error('Error fetching customer detail for partyId: ' + r.partyId, e);
                                return r;
                            }
                        }
                        return r;
                    }));
                    console.log('--- DBG: resolvedRolesWithDetail (Final List):', resolvedRolesWithDetail);

                    updatedRecipients = documentRecipients.map(rec => {
                        const recRole = (rec.roleTypeId || '').toString().trim();
                        const resolved = resolvedRolesWithDetail.find((r: any) => 
                            (r.roleTypeId || '').toString().trim() === recRole
                        );
                        
                        console.log(`--- DBG: Matching rec role "${recRole}" ->`, resolved ? 'FOUND' : 'NOT FOUND');

                        if (resolved) {
                            const pId = resolved.partyId || '';
                            const pType = resolved.partyTypeEnumId || (resolved.taxCode ? 'PtyOrganization' : 'PtyPerson');
                            const pName = resolved.partyName || resolved.description || '';
                            const tCode = resolved.taxCode || resolved.taxId || resolved.partyTaxId || resolved.pseudoId || '';
                            
                            return {
                                ...rec,
                                partyId: pId,
                                partyTypeEnumId: pType,
                                taxCode: tCode,
                                partyName: pName,
                                emailAddress: resolved.emailAddress || '',
                                representativeName: resolved.representativeName || resolved.repName || '',
                                contactNumber: resolved.contactNumber || resolved.phone || '',
                                identityCard: resolved.identityCard || '',
                                party: pId ? { 
                                    value: pId, 
                                    label: `[${resolved.pseudoId || 'Mới'}] - ${pName}`,
                                    partyId: pId,
                                    partyTypeEnumId: pType,
                                    partyName: pName,
                                    taxCode: tCode,
                                    emailAddress: resolved.emailAddress
                                } : null,
                                isAutoFilled: !!pId
                            };
                        }
                        return rec;
                    });
                    console.log('--- DBG: Final updatedRecipients:', updatedRecipients);
                    setDocumentRecipients(updatedRecipients);
                }

                // Tự động mapping vị trí ký (Resolved Locations)
                if (Array.isArray(res.resolvedLocations) && res.resolvedLocations.length > 0) {
                    const mappedPositions = res.resolvedLocations.map((pos: any, idx: number) => {
                        const recipient = updatedRecipients.find(r => r.roleTypeId === pos.roleTypeId);
                        return {
                            locationSeqId: pos.locationSeqId || formatSeq(idx + 1),
                            internalRecipientId: recipient?._internalId,
                            x: Number(pos.ulx ?? pos.llx ?? pos.x ?? 0),
                            y: Number(pos.uly ?? pos.lly ?? pos.y ?? 0),
                            pageIndex: pos.pageIndex !== undefined && pos.pageIndex !== null ? Number(pos.pageIndex) : (Number(pos.pageNumber ?? 1) - 1),
                            widthPx: Number(pos.widthPx ?? 200),
                            heightPx: Number(pos.heightPx ?? 65),
                            fontSize: Number(pos.fontSize ?? 12),
                            signatureTypeEnumId: pos.signatureTypeEnumId || 'AgtDigitalVerified',
                            roleTypeId: pos.roleTypeId || '',
                            partyName: recipient?.partyName || pos.partyName || pos.roleTypeId || '',
                            label: recipient?.partyName || pos.partyName || pos.roleTypeId || '',
                            fileId: newFileId
                        };
                    });
                    setSignaturePositions(normalizeLocationSeq(mappedPositions));
                }

                return true;
            }
            return false;
        } catch (err) {
            ToastService.error('Không thể điền thông tin vào mẫu');
            console.error(err);
            return false;
        } finally {
            setFillingTemplate(false);
        }
    };

    const detectFieldType = (field: any): string => {
        const enumId = (field.fieldTypeEnumId || '');
        
        // Theo chuẩn Enumeration của đại ca
        if (enumId === 'DBFFAT_text-medium') return 'AgtFftText';
        if (enumId === 'DBFFAT_date-short' || enumId === 'DBFFAT_date-long') return 'AgtFftDate';
        if (enumId === 'DBFFAT_checkbox') return 'AgtFftCheckbox';

        // Fallback nhẹ cho trường hợp enum không khớp chính xác nhưng có từ khóa
        const lowerEnumId = enumId.toLowerCase();
        if (lowerEnumId.includes('date')) return 'AgtFftDate';
        if (lowerEnumId.includes('checkbox')) return 'AgtFftCheckbox';
        if (lowerEnumId.includes('number') || enumId === 'DBFFAT_number') return 'AgtFftNumber';
        
        return 'AgtFftText';
    };

    const loadPDFToCanvas = async (file: any) => {
        if (!file) return;
        setCanvasLoading(true);
        setPageCanvases([]);
        console.log('>>> loadPDFToCanvas file:', file);
        try {
            let arrayBuffer: ArrayBuffer;
            const fileId = file.referenceFileId || file.googleFileId;
            if (fileId) {
                const blob = await AgreementService.downloadPdf(fileId);
                arrayBuffer = await blob.arrayBuffer();
            } else if (file.file) {
                arrayBuffer = await file.file.arrayBuffer();
            } else return;

            const loadingTask = getDocument({ data: arrayBuffer });
            const pdf = await loadingTask.promise;
            const canvases = await Promise.all(
                Array.from({ length: pdf.numPages }, (_, i) => i + 1).map(async (num) => {
                    const page = await pdf.getPage(num);
                    const viewport = page.getViewport({ scale: 1.5 });
                    const canvas = document.createElement('canvas');
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
                    await page.render({ canvasContext: canvas.getContext('2d')!, viewport }).promise;
                    return canvas;
                })
            );
            setPageCanvases(canvases);
        } catch (err) {
            console.error('PDF Load Error:', err);
        } finally {
            setCanvasLoading(false);
        }
    };

    useEffect(() => {
        const stepTarget = 2 + (hasTemplateFields ? 1 : 0);
        if (createStep === stepTarget && mainFiles.length > 0) {
            const file = mainFiles[activeMainFileIndex];
            // Chỉ load nếu là PDF hoặc đã có bản preview PDF
            if (file && (file.extension === 'pdf' || file.referenceFileId)) {
                loadPDFToCanvas(file);
            }
        }
    }, [createStep, mainFiles, hasTemplateFields, activeMainFileIndex]);

    const handleDrop = (event: any, pageIndex: number) => {
        const rect = canvasRefs.current[pageIndex]?.getBoundingClientRect();
        if (!rect) return;

        const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max);
        const cursorX = event.clientX - rect.left;
        const cursorY = event.clientY - rect.top;

        const defaultWidth = selectedSignatureType === 'AgtImageVerified' ? 300 : 200;
        const defaultHeight = selectedSignatureType === 'AgtImageVerified' ? 100 : 65;
        const xMax = rect.width - defaultWidth;
        const yMax = rect.height - defaultHeight;
        const x = clamp(cursorX, 0, Math.max(0, xMax));
        const y = clamp(cursorY, 0, Math.max(0, yMax));

        const internalRecipientId = selectedSigner?._internalId || selectedSigner?.internalRecipientId || null;
        const recipient = documentRecipients.find(r => r._internalId === internalRecipientId);
        const partyInfo = recipient?.party || {};

        const rawLabel = recipient?.party?.label || recipient?.partyName || (selectedSigner && selectedSigner.label) || 'Chưa chọn người ký';
        const cleanLabelMatch = String(rawLabel).match(/\]\s*-\s*(.+)$/);
        const displayLabel = cleanLabelMatch ? cleanLabelMatch[1] : String(rawLabel);

        const newPos: any = {
            locationSeqId: formatSeq(signaturePositions.length + 1),
            x, y, pageIndex,
            fileId: mainFiles[activeMainFileIndex]?.fileId || mainFiles[activeMainFileIndex]?.googleFileId || null,
            widthPx: defaultWidth, 
            heightPx: defaultHeight, 
            fontSize: 12,
            signatureTypeEnumId: selectedSignatureType,
            partyId: recipient?.partyId || null,
            internalRecipientId: internalRecipientId,
            partyName: recipient?.partyName || partyInfo.partyName || displayLabel,
            roleTypeId: recipient?.roleTypeId || (selectedSigner && selectedSigner.roleTypeId) || null,
            label: displayLabel
        };

        if (recipient) {
            newPos.taxCode = recipient.taxCode || partyInfo.partyTaxId || partyInfo.taxCode || '';
            newPos.emailAddress = recipient.emailAddress || partyInfo.emailAddress || '';
            newPos.contactNumber = recipient.contactNumber || partyInfo.contactNumber || '';
            newPos.representativeName = recipient.representativeName || partyInfo.representativeName || '';
            newPos.identityCard = recipient.identityCard || partyInfo.idValue || partyInfo.identityCard || '';
        }

        setSignaturePositions(prev => normalizeLocationSeq([...prev, newPos]));
    };

    const handleDragStop = (event: any, data: any, id: string) => {
        setSignaturePositions(prev => prev.map(p => {
            if (p.locationSeqId === id) {
                const canvas = pageCanvases[p.pageIndex];
                if (!canvas) return { ...p, x: data.x, y: data.y };

                const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max);
                const maxX = canvas.width - (p.widthPx || 200);
                const maxY = canvas.height - (p.heightPx || 65);
                return { 
                    ...p, 
                    x: clamp(data.x, 0, Math.max(0, maxX)), 
                    y: clamp(data.y, 0, Math.max(0, maxY)) 
                };
            }
            return p;
        }));
    };
    useEffect(() => {
        if (!selectedSigner) return;
        setSignaturePositions(prev => normalizeLocationSeq(prev.map(pos => {
            const updated = { ...pos } as any;
            const pid = selectedSigner.partyId || selectedSigner.value || (typeof selectedSigner === 'string' ? selectedSigner : null);
            if (!updated.partyId) updated.partyId = pid;
            if (!updated.roleTypeId) updated.roleTypeId = selectedSigner.roleTypeId || null;
            if (!updated.partyName && selectedSigner.label) {
                const cleanLabelMatch = String(selectedSigner.label).match(/\]\s*-\s*(.+)$/);
                updated.partyName = cleanLabelMatch ? cleanLabelMatch[1] : String(selectedSigner.label);
            }
            return updated;
        })));
    }, [selectedSigner]);

    useEffect(() => {
        console.log('DocumentRecipients changed:', documentRecipients);
        setSignaturePositions(prev => {
            console.log('Current signaturePositions (before filter):', prev);
            const updated = prev.map(pos => {
                const pid = pos.partyId;
                const recipient = documentRecipients.find(r => {
                    const rPid = r.partyId || r.party?.partyId || r.party?.value;
                    if (pid && rPid && String(pid) === String(rPid)) return true;
                    // Nếu là template, ưu tiên match bằng roleTypeId nếu partyId không khớp hoặc bị thay đổi
                    if ((isCreatingFromTemplate || fillingTemplate) && pos.roleTypeId && String(r.roleTypeId) === String(pos.roleTypeId)) return true;
                    if (!pid && pos.roleTypeId && String(r.roleTypeId) === String(pos.roleTypeId)) return true;
                    return false;
                });
                if (!recipient) return pos;

                const partyInfo = recipient.party || {};
                const rawLabel = recipient.party?.label || recipient.partyName || 'Chưa chọn người ký';
                const cleanLabelMatch = String(rawLabel).match(/\]\s*-\s*(.+)$/);
                const displayLabel = cleanLabelMatch ? cleanLabelMatch[1] : String(rawLabel);

                return {
                    ...pos,
                    partyId: recipient.partyId || recipient.party?.partyId || recipient.party?.value || pos.partyId,
                    label: displayLabel,
                    partyName: recipient.partyName || partyInfo.partyName || displayLabel,
                    taxCode: recipient.taxCode || partyInfo.partyTaxId || partyInfo.taxCode || '',
                    emailAddress: recipient.emailAddress || partyInfo.emailAddress || '',
                    contactNumber: recipient.contactNumber || partyInfo.contactNumber || '',
                    representativeName: recipient.representativeName || partyInfo.representativeName || '',
                    identityCard: recipient.identityCard || partyInfo.idValue || partyInfo.identityCard || '',
                    roleTypeId: recipient.roleTypeId || pos.roleTypeId
                };
            }).filter(pos => {
                const isMatch = documentRecipients.some(r => {
                    const rPid = r.partyId || r.party?.partyId || r.party?.value;
                    const posPid = pos.partyId;
                    // Match bằng partyId nếu cả 2 đều có
                    if (rPid && posPid && String(rPid) === String(posPid)) return true;
                    // Match bằng roleTypeId (quan trọng cho template và khi mới gán người ký)
                    if (pos.roleTypeId && String(r.roleTypeId) === String(pos.roleTypeId)) return true;
                    return false;
                });
                if (!isMatch) console.log('Filtering out position due to no matching recipient:', pos);
                return isMatch;
            });
            console.log('Final signaturePositions (after filter):', updated);
            return normalizeLocationSeq(updated);
        });
    }, [documentRecipients]);


    useEffect(() => {
        if (!displayCreateDialog) return;
        CommonService.agreementRoleTypes().then((data: any) => {
            const list = data?.listData || data?.list || (Array.isArray(data) ? data : []);
            if (list.length > 0) setRoleOptions(list.map((it: any) => ({ value: it.roleTypeId, label: it.description })));
        }).catch(err => console.error('Load role types failed:', err));
        CustomerService.find('').then((data: any) => {
            const list = data?.listData || data?.list || [];
            if (list.length > 0) {
                const mapped = list.map((it: any) => ({ value: it.partyId, label: `[${it.pseudoId}] - ${it.partyName}` }));
                setCustomers(mapped);
                setCustomerSuggestions(mapped);
            }
        }).catch(err => console.error('Load customers failed:', err));
    }, [displayCreateDialog]);

    const getRoleOptionsForRow = (idx: number) => roleOptions;
    const getCustomerSuggestionsForRow = (idx: number) => customerSuggestions;
    const [statuses, setStatuses] = useState<any[]>([]);
    const handleSign = (item: any) => {
        if (!item?.agreementId) return;
        AgreementService.unsignedParties(item.agreementId).then(res => {
            const parties = (res?.agreementParties || []).map((p: any) => ({
                ...p,
                checked: p.checked === 'Y',
                dataKey: `${p.roleTypeId}-${p.partyId}`
            }));
            setAgreementParties(parties);
            setDisplaySignerDialog({ agreementId: item.agreementId, agreementName: item.agreementName });
        });
    };

    const handleCancel = (item: any) => {
        if (!item?.agreementId) return;
        setCancelDialog(item);
        setCancelReason('');
    };

    const handleConvertToDraft = (item: any) => {
        if (!item?.agreementId) return;
        AgreementService.convertToDraft(item.agreementId).then(res => {
            if (res && res.success === 'Y') {
                ToastService.success('Đã chuyển tài liệu về nháp');
                setActiveTabIndex(0);
                reloadLazyData();
            } else {
                ToastService.error(res?.error || 'Không thể chuyển tài liệu về nháp');
            }
        }).catch(() => ToastService.error('Có lỗi khi chuyển tài liệu về nháp'));
    };

    // Handlers for Draft tab
    const handleView = (rowData: any) => {
        console.log('>>> handleView click:', rowData);
        if (!rowData?.agreementId) {
            console.error('>>> handleView ERROR: agreementId is missing', rowData);
            ToastService.error('Không tìm thấy ID tài liệu');
            return;
        }
        navigate(`/quan-ly-tai-lieu/tai-lieu/${rowData.agreementId}?mode=view`);
    };


    const handleEdit = (rowData: any) => {
        navigate(`/quan-ly-tai-lieu/tai-lieu/${rowData.agreementId}`);
    };

    const handleSignFromDraft = (rowData: any) => {
        try {
            AgreementService.signAgreement(rowData.agreementId).then(res => {
                if (res && res.success === 'Y') {
                    try {
                        if (typeof window !== 'undefined' && window.localStorage) {
                            window.localStorage.setItem('econtract.taiLieuKy.activeTab', '1');
                        }
                    } catch (err) {
                    }
                    setActiveTabIndex(1);
                    reloadLazyData();
                } else {
                    ToastService.error(res?.error || 'Không thể ký hợp đồng');
                }
            });
        } catch (e) {
            ToastService.error('Có lỗi khi ký hợp đồng');
        }
    };

    const handleDelete = async (rowData: any) => {
        try {
            const res = await AgreementService.moveToTrash(rowData.agreementId);
            if (res && res.success === 'Y') {
                ToastService.success('Đã chuyển vào thùng rác');
                setActiveTabIndex(4);
                try {
                    if (typeof window !== 'undefined' && window.localStorage) {
                        window.localStorage.setItem('econtract.taiLieuKy.activeTab', '4');
                    }
                } catch (err) { }
                reloadLazyData();
            } else {
                ToastService.error(res?.error || 'Không thể chuyển vào thùng rác');
            }
        } catch (e) {
            ToastService.error('Có lỗi khi chuyển vào thùng rác');
        }
    };

    // Handler for Trash tab
    const handleRestore = async (rowData: any) => {
        try {
            const id = rowData.agreementId;
            const res = await AgreementService.restoreAgreement(id);
            if (res && res.success === 'Y') {
                ToastService.success('Đã khôi phục tài liệu');
                setActiveTabIndex(0);
                try {
                    if (typeof window !== 'undefined' && window.localStorage) {
                        window.localStorage.setItem('econtract.taiLieuKy.activeTab', '0');
                    }
                } catch (err) { }
                reloadLazyData();
            } else {
                ToastService.error(res?.error || 'Không thể khôi phục tài liệu');
            }
        } catch (e) {
            ToastService.error('Có lỗi khi khôi phục tài liệu');
        }
    };

    const handleSendEmail = (item: any) => {
        if (!item?.agreementId) return;
        AgreementService.unsignedParties(item.agreementId).then(res => {
            const parties = (res?.agreementParties || []).map((p: any) => ({
                ...p,
                checked: false,
                dataKey: `${p.roleTypeId}-${p.partyId}`
            }));
            setEmailParties(parties);
            setDisplayEmailDialog({ agreementId: item.agreementId, agreementName: item.agreementName });
        }).catch(() => {
            ToastService.error('Không thể tải danh sách đối tượng');
        });
    };

    const confirmCancel = () => {
        if (!cancelDialog?.agreementId) return;
        const reason = cancelReason.trim();
        if (!reason) {
            ToastService.error('Vui lòng nhập lý do hủy');
            return;
        }
        const agreementId = cancelDialog.agreementId;
        setCancelDialog(null);
        setCancelReason('');
        AgreementService.cancelAgreement(agreementId, { cancelReason: reason }).then(res => {
            if (!res.errors) {
                ToastService.success('Đã hủy tài liệu');
                setActiveTabIndex(3);
                try {
                    if (typeof window !== 'undefined' && window.localStorage) {
                        window.localStorage.setItem('econtract.taiLieuKy.activeTab', '3');
                    }
                } catch (err) { }
                reloadLazyData();
            } else {
                ToastService.error(res?.errors || 'Không thể hủy tài liệu');
            }
        }).catch(() => ToastService.error('Có lỗi khi hủy tài liệu'));
    };

    const { render: renderSignerTable } = useDataTableBasic({
        tableHeader: 'Đối tượng',
        dataKey: 'dataKey',
        indexColumnWidth: 45,
        columns: [
            {
                field: 'checked', header: 'Chọn', width: 120,
                dataType: 'editor', editorConfig: {
                    onEditorChange(rowData: any, column: any, newValue: any) {
                        setAgreementParties(prev => prev.map(it => it.dataKey === rowData.dataKey ? { ...it, checked: newValue } : { ...it, checked: false }));
                    },
                    field: { type: 'Checkbox' }
                }, className: 'text-center'
            },
            { field: 'partyName', header: 'Tên đối tượng', minWidth: 150 },
            { field: 'roleType', header: 'Vai trò', minWidth: 75 },
            { field: 'emailAddress', header: 'Email', minWidth: 100 },
            { field: 'contactNumber', header: 'SĐT', minWidth: 90 },
            { header: 'MST/CCCD/CMND', minWidth: 120, dataType: 'custom', customCell(row: any) { return row.taxCode || row.identityCard || ''; } }
        ],
        items: agreementParties
    });

    const { render: renderEmailTable } = useDataTableBasic({
        tableHeader: 'Đối tượng',
        dataKey: 'dataKey',
        indexColumnWidth: 45,
        columns: [
            {
                field: 'checked', header: 'Chọn', width: 120,
                dataType: 'editor', editorConfig: {
                    onEditorChange(rowData: any, column: any, newValue: any) {
                        setEmailParties(prev => prev.map(it => it.dataKey === rowData.dataKey ? { ...it, checked: newValue } : it));
                    },
                    field: { type: 'Checkbox' }
                }, className: 'text-center'
            },
            { field: 'partyName', header: 'Tên đối tượng', minWidth: 150 },
            { field: 'roleType', header: 'Vai trò', minWidth: 75 },
            { field: 'emailAddress', header: 'Email', minWidth: 100 },
            { field: 'contactNumber', header: 'SĐT', minWidth: 90 },
            { header: 'MST/CCCD/CMND', minWidth: 120, dataType: 'custom', customCell(row: any) { return row.taxCode || row.identityCard || ''; } }
        ],
        items: emailParties
    });

    const submitSignSelected = async () => {
        const selected = agreementParties.find(p => p.checked === true);
        if (!selected) { ToastService.error('Chưa chọn đối tượng ký.'); return; }
        if (isSigning) return;
        setIsSigning(true);
        try {
            const row = selected;
            const signResult = await DocumentSignService.sign({
                agreementId: row.agreementId,
                partyId: row.partyId,
                roleTypeId: row.roleTypeId
            });

            if (signResult?.success && signResult?.data) {
                const { signedAgreements, signedFiles, signedFilesBase64 } = signResult.data;

                let pushParams: any = {
                    signedBy: row.roleTypeId === 'SellerSignedExec' ? 'SELLER' : 'BUYER',
                    agreementId: row.agreementId,
                    partyId: row.partyId,
                    roleTypeId: row.roleTypeId,
                    referenceNumber: null,
                    signingSecretCode: ''
                };

                if (signedAgreements && Array.isArray(signedAgreements) && signedAgreements.length > 0) {
                    // Cấu trúc lồng nhau mới: signedAgreements -> files
                    pushParams.signedFiles = signedAgreements.flatMap((ag: any) =>
                        (ag.files || []).map((f: any) => ({
                            agreementContentId: f.agreementContentId,
                            base64FileData: f.base64FileData
                        }))
                    );
                } else if (signedFiles && Array.isArray(signedFiles) && signedFiles.length > 0) {
                    // Tương thích ngược: signedFiles phẳng kèm agreementContentId
                    pushParams.signedFiles = signedFiles.map((sf: any) => ({
                        agreementContentId: sf.agreementContentId,
                        base64FileData: sf.base64FileData
                    }));
                } else if (signedFilesBase64 && Array.isArray(signedFilesBase64) && signedFilesBase64.length > 0) {
                    // Tương thích ngược cũ: array string base64
                    pushParams.base64FileData = signedFilesBase64[0];
                }

                await AgreementService.pushSignedData(pushParams);
                ToastService.success('Ký số thành công!');
            } else {
                try { 
                    await AgreementService.updateSigningError({ 
                        agreementId: row.agreementId, 
                        partyId: row.partyId, 
                        roleTypeId: row.roleTypeId, 
                        referenceNumber: null, 
                        signingSecretCode: '' 
                    }); 
                } catch { 
                    ToastService.error('Có lỗi khi ký/lưu file từ server.');
                }
            }
            setDisplaySignerDialog(null);
            reloadLazyData();
        } catch (e) {
            ToastService.error('Có lỗi khi ký/lưu file từ server.');
        } finally {
            setIsSigning(false);
        }
    };

    const submitEmailSelected = async () => {
        const selected = emailParties.filter(p => p.checked === true);
        if (selected.length === 0) {
            ToastService.error('Chưa chọn đối tượng để gửi email.');
            return;
        }
        if (!displayEmailDialog?.agreementId) return;
        if (sendingEmail) return;

        setSendingEmail(true);
        try {
            const agreementPartiesData = selected.map(p => ({
                partyId: p.partyId,
                roleTypeId: p.roleTypeId,
                toAddresses: p.emailAddress || ''
            }));

            await AgreementService.sentEmailNotifyBuyer(displayEmailDialog.agreementId, {
                agreementParties: agreementPartiesData,
                subject: `Thông báo hợp đồng cần ký - ${displayEmailDialog.agreementName || ''}`
            });

            ToastService.success('Gửi email thành công!');
            setDisplayEmailDialog(null);
            setEmailParties([]);
            reloadLazyData();
        } catch (error: any) {
            const errorMsg = error?.response?.data?.errors || error?.message || 'Có lỗi khi gửi email';
            ToastService.error(errorMsg);
        } finally {
            setSendingEmail(false);
        }
    };

    const downloadFile = async (fileId?: string, fileName?: string) => {
        if (!fileId) {
            ToastService.error('Không tìm thấy file để tải');
            return;
        }
        try {
            const blob = await AgreementService.downloadPdf(fileId);
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName || 'document.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            ToastService.success('Đã tải file thành công');
        } catch (error) {
            ToastService.error('Không thể tải file');
        }
    };

    const extractViewFileId = (file: any) => {
        if (!file) return null;
        return file.referenceFileId || null;
    };

    const extractOriginalFileId = (file: any) => {
        if (!file) return null;
        return file.googleFileId || file.fileId || file.agreementContentId || file.id;
    };

    const extractGoogleFileId = (file: any) => {
        if (file?.referenceFileId) return file.referenceFileId;
        if (file?.fileId) return file.fileId;
        if (file?.googleFileId) return file.googleFileId;
        
        // Extract from contentLocation if it's a Google Drive URL
        const location = file?.contentLocation || file?.googleFileUrl;
        if (location && typeof location === 'string') {
            const match = location.match(/\/d\/([a-zA-Z0-9_-]+)/);
            if (match && match[1]) return match[1];
        }
        
        return file?.agreementContentId || file?.id || file?.contentId || file?.description;
    };

    const openPdfInNewTab = async (file: any) => {
        console.log('openPdfInNewTab click file:', file);
        const fileId = file.fileId || file.googleFileId || file.id;

        let targetId = extractViewFileId(file);
        if (!targetId) {
            if (pdfGenerating.has(fileId)) {
                ToastService.error('Bản xem trước đang được xử lý, vui lòng đợi xíu nha!');
                return;
            }
            try {
                ToastService.error('Đang chuẩn bị bản xem trước, vui lòng đợi ít giây...');
                const res = await AgreementService.generatePdf(fileId, file.name || file.fileName, file.contentType, file.agreementContentId);
                if (res && (res.referenceFileId || res.fileId)) {
                    targetId = res.referenceFileId || res.fileId;
                }
            } catch (err) {
                console.error('Lỗi khi chuẩn bị file PDF:', err);
            }
        }

        if (!targetId) {
            if (toast.current) {
                toast.current.show({ severity: 'error', summary: 'Lỗi', detail: 'Bản xem trước chưa sẵn sàng, vui lòng thử lại sau ít phút!' });
            } else {
                ToastService.error('Bản xem trước chưa sẵn sàng, vui lòng thử lại sau ít phút!');
            }
            return;
        }
        
        // Chuyển sang dùng fileId cho Viewer thay vì blob URL trực tiếp
        setSelectedFile(file);
        setViewerUrl(targetId);
        setViewerFileName(file.name || file.fileName || '');
        setCurrentPage(1);
        setShowFileViewer(true);
    };

    const closeFileViewer = () => {
        setViewerUrl(null);
        setViewerFileName('');
        setShowFileViewer(false);
        setSelectedFile(null);
        setCurrentPage(1);
    };

    const handleShowFiles = async (item: any) => {
        if (!item?.agreementId) return;
        try {
            const data = await AgreementService.getAgreementFiles(item.agreementId);
            setFileDialogMainFiles(data?.mainFiles || []);
            setFileDialogAttachmentFiles(data?.attachmentFiles || []);
            setFileDialogMainFileReady({});
            setFileDialogAttachmentFileReady({});
            setFileDialogMainFileBlobUrls({});
            setFileDialogAttachmentFileBlobUrls({});
            fileDialogMainFileBlobUrlsRef.current = {};
            fileDialogAttachmentFileBlobUrlsRef.current = {};
            setFileDialogViewingAttachmentIndex(null);
            setFileDialogActiveTabIndex(0);
            setDisplayFileDialog({ agreementId: item.agreementId, agreementName: item.agreementName });
        } catch (error) {
            ToastService.error('Không thể tải danh sách file');
        }
    };


    const getUploadDialogFileTypeName = (item: any): string => {
        if (!item) return 'Không có mô tả';
        const fileTypeId = item.fileTypeEnumId || item.fileTypeId;
        if (!fileTypeId || uploadDialogFileTypes.length === 0) return item.description || 'Không có mô tả';
        const fileType = uploadDialogFileTypes.find((ft: any) => ft.enumId === fileTypeId || ft.enumCode === fileTypeId);
        return fileType?.description || item.description || 'Không có mô tả';
    };



    const uploadDialogFormTypeOptions = useMemo(() => {
        if (uploadDialogFileTypes.length > 0) {
            return uploadDialogFileTypes.map((ft: any) => ({
                label: String(ft.description || ft.enumName || ft.enumId || ''),
                value: String(ft.enumId || ft.value || ft.enumCode || ''),
                enumCode: ft.enumCode ? String(ft.enumCode) : String(ft.enumId || '')
            }));
        }
        return [];
    }, [uploadDialogFileTypes]);

    const [activeTabIndex, setActiveTabIndex] = useState(0);

    useEffect(() => {
        try {
            if (typeof window !== 'undefined' && window.localStorage) {
                const savedIndex = window.localStorage.getItem('econtract.taiLieuKy.activeTab');
                if (savedIndex !== null) {
                    const parsed = parseInt(savedIndex, 10);
                    if (!Number.isNaN(parsed)) {
                        setActiveTabIndex(parsed);
                    }
                }
            }
        } catch (e) {
        }
    }, []);

    const handleTabChange = (e: { index: number }) => {
        const newIndex = e.index;
        setActiveTabIndex(newIndex);
        try {
            if (typeof window !== 'undefined' && window.localStorage) {
                window.localStorage.setItem('econtract.taiLieuKy.activeTab', String(newIndex));
            }
        } catch (err) {
        }
    };

    const reloadDraftRef = useRef<() => void>(() => { });
    const reloadInProgressRef = useRef<() => void>(() => { });
    const reloadCompletedRef = useRef<() => void>(() => { });
    const reloadCancelledRef = useRef<() => void>(() => { });
    const reloadTrashRef = useRef<() => void>(() => { });

    // Tab components are now extracted to ./components/tabs/

    const reloadLazyData = () => {
        reloadDraftRef.current();
        reloadInProgressRef.current();
        reloadCompletedRef.current();
        reloadCancelledRef.current();
        reloadTrashRef.current();
    };

    useEffect(() => { reloadLazyData(); }, []);

    useEffect(() => {
        // No longer need to pre-load main files into blob URLs for the file dialog
        // The main file viewer will handle loading on demand via PdfCanvasViewer
        // This useEffect can be removed or simplified if no other logic depends on fileDialogMainFileReady
        if (!displayFileDialog) return;
        setFileDialogMainFileReady({}); // Reset ready state
    }, [fileDialogMainFiles, displayFileDialog]);

    useEffect(() => {
        return () => {
            // Clean up blob URLs only if they were created
            Object.values(fileDialogMainFileBlobUrlsRef.current).forEach(url => {
                if (url && url.startsWith('blob:')) {
                    URL.revokeObjectURL(url);
                }
            });
            Object.values(fileDialogAttachmentFileBlobUrlsRef.current).forEach(url => {
                if (url && url.startsWith('blob:')) {
                    URL.revokeObjectURL(url);
                }
            });
            // No longer need to explicitly close editor permissions here if PdfCanvasViewer handles it
            // or if openPdfInNewTab is the only entry point for viewing
            fileDialogOpenedFileIdsRef.current.clear();
        };
    }, []);

    const closeFileDialog = () => {
        // No longer need to explicitly close editor permissions here if PdfCanvasViewer handles it
        // or if openPdfInNewTab is the only entry point for viewing
        fileDialogOpenedFileIdsRef.current.clear();
        setDisplayFileDialog(null);
    };

    const handleUploadAttachment = async (event: any) => {
        if (!displayUploadAttachmentDialog?.agreementId) return;

        const files = event.files;
        if (!files || files.length === 0) {
            ToastService.error('Vui lòng chọn file để upload');
            return;
        }

        setUploadingAttachment(true);
        try {
            for (const file of files) {
                const res = await AgreementService.uploadFile(file);
                if (!(res && res.success === 'Y')) {
                    throw new Error(res?.error || `Không thể upload ${file.name}`);
                }
            }
            ToastService.success('Upload file đính kèm thành công');
            setDisplayUploadAttachmentDialog(null);
            if (fileUploadAttachmentRef.current) {
                fileUploadAttachmentRef.current.clear();
            }
            reloadLazyData();
        } catch (error: any) {
            ToastService.error(error?.message || 'Có lỗi khi upload file đính kèm');
        } finally {
            setUploadingAttachment(false);
        }
    };

    useEffect(() => {
        if (!displayUploadAttachmentDialog?.agreementId) return;

        const loadData = async () => {
            try {
                const infoRes = await AgreementService.getAgreementInfo(displayUploadAttachmentDialog.agreementId);
                if (infoRes && infoRes.success === 'Y') {
                    const mappedAttached = (infoRes.attachmentFiles || [])
                        .filter((f: any) => f.fileId)
                        .map((f: any, idx: number) => {
                            const seqNum = f.sequenceNum ?? f.configSequenceNum ?? f.agreementItemSeq ?? null;
                            const normalizedSeq = seqNum !== null && seqNum !== undefined ? Number(seqNum) : null;
                            const fileName = f.fileName || '';
                            const extension = fileName ? getFileExtension(fileName) : '';
                            const agreementContentId = f.agreementContentId;
                            return {
                                agreementContentId: agreementContentId,
                                name: fileName,
                                size: 0,
                                type: f.contentType,
                                file: undefined,
                                extension,
                                googleFileId: f.fileId,
                                fileId: f.fileId,
                                id: f.fileId,
                                googleFileUrl: f.contentLocation,
                                contentLocation: f.contentLocation,
                                referenceFileId: f.referenceFileId,
                                isMainFile: false,
                                sequenceNum: normalizedSeq,
                                configSequenceNum: normalizedSeq,
                                agreementFormTypeEnumId: f.agreementFormTypeEnumId || null,
                                agreementFormDate: f.agreementFormDate || null
                            };
                        });
                    setUploadDialogAttachedFiles(mappedAttached);

                    const items = Array.isArray(infoRes.attachmentFiles) ? infoRes.attachmentFiles : [];
                    setUploadDialogDocumentTypeItems(items);

                    const meta: Record<string, { formType?: string | null; receivedDate?: Date | null }> = {};
                    items.forEach((item: any, idx: number) => {
                        const seq = resolveConfigItemSeq(item, idx);
                        if (!seq) return;
                        const seqKey = String(seq);
                        const existingFile = mappedAttached.find((f: any) => Number(f.sequenceNum ?? f.configSequenceNum) === Number(seq));
                        const fileFormType = existingFile ? normalizeFormTypeValue(existingFile.agreementFormTypeEnumId) : null;
                        const fileDate = existingFile?.agreementFormDate ? new Date(existingFile.agreementFormDate) : null;
                        meta[seqKey] = {
                            formType: normalizeFormTypeValue(fileFormType ?? null),
                            receivedDate: fileDate ?? null
                        };
                    });
                    setUploadDialogDocumentTypeItemMeta(meta);
                }
            } catch (error) {
                ToastService.error('Không thể tải thông tin tài liệu');
            }
        };

        loadData();
    }, [displayUploadAttachmentDialog]);

    useEffect(() => {
        CommonService.getFileTypes()
            .then((res: any) => {
                if (res?.listData && Array.isArray(res.listData)) {
                    setUploadDialogFileTypes(res.listData);
                } else if (Array.isArray(res?.list)) {
                    setUploadDialogFileTypes(res.list);
                } else if (Array.isArray(res)) {
                    setUploadDialogFileTypes(res);
                } else {
                    setUploadDialogFileTypes([]);
                }
            })
            .catch(() => {
                setUploadDialogFileTypes([]);
            });
    }, []);

    const handleUploadDialogItemUpload = (item: any, idx: number) => {
        if (!displayUploadAttachmentDialog?.agreementId) return;
        const seq = resolveConfigItemSeq(item, idx);
        if (!seq) {
            ToastService.error('Không xác định được hạng mục file.');
            return;
        }
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.pdf,.doc,.docx';
        input.onchange = (e: any) => {
            const file = e.target.files?.[0];
            if (!file) return;

            const tempId = `temp-${Date.now()}`;
            const placeholder = {
                name: file.name,
                size: file.size,
                type: file.type,
                fileId: tempId,
                id: tempId,
                isMainFile: false,
                sequenceNum: seq,
                configSequenceNum: seq,
                uploading: true,
                extension: getFileExtension(file.name)
            };

            setUploadDialogAttachedFiles(prev => {
                const filtered = prev.filter(f => Number(f?.sequenceNum ?? f?.configSequenceNum) !== Number(seq));
                return [...filtered, placeholder];
            });

            AgreementService.uploadFile(file)
                .then(res => {
                    if (res && res.success === 'Y') {
                        const uploadedFile = {
                            name: res.fileName || file.name,
                            size: file.size,
                            type: file.type,
                            googleFileId: res.fileId,
                            fileId: res.fileId,
                            googleFileUrl: res.fileUrl,
                            referenceFileId: res.referenceFileId,
                            isMainFile: false,
                            sequenceNum: seq,
                            configSequenceNum: seq,
                            extension: res.format || getFileExtension(file.name),
                            contentType: res.contentType || file.type
                        };
                        setUploadDialogAttachedFiles(prev => prev.map(f => f.fileId === tempId ? uploadedFile : f));

                        // Gọi Async tạo PDF nếu chưa có referenceFileId
                        const ext = uploadedFile.extension;
                        if (ext !== 'pdf' && !uploadedFile.referenceFileId) {
                            setPdfGenerating(prev => new Set(prev).add(res.fileId));
                            AgreementService.generatePdf(res.fileId, uploadedFile.name, uploadedFile.contentType)
                                .then(pdfRes => {
                                    if (pdfRes?.referenceFileId) {
                                        setUploadDialogAttachedFiles(prev => prev.map(f => f.fileId === res.fileId ? { ...f, referenceFileId: pdfRes.referenceFileId } : f));
                                    }
                                })
                                .finally(() => {
                                    setPdfGenerating(prev => {
                                        const next = new Set(prev);
                                        next.delete(res.fileId);
                                        return next;
                                    });
                                });
                        }
                        ToastService.success(`Đã gắn tệp cho hạng mục #${seq}`);
                    } else {
                        throw new Error(res?.error || `Không thể upload ${file.name}`);
                    }
                })
                .catch(err => {
                    ToastService.error(err.message || 'Lỗi khi tải tệp lên');
                    setUploadDialogAttachedFiles(prev => prev.filter(f => f.fileId !== tempId));
                });
        };
        input.click();
    };

    const handleUploadDialogItemMetaChange = (seqKey: string, field: 'formType' | 'receivedDate', value: any) => {
        const nextValue = field === 'formType' ? normalizeFormTypeValue(value) : value;
        setUploadDialogDocumentTypeItemMeta(prev => ({
            ...prev,
            [seqKey]: {
                ...prev[seqKey],
                [field]: nextValue
            }
        }));
    };

    const handleUploadDialogViewFile = async (file: any) => {
        handleViewFile(file);
    };

    const handleCloseUploadDialogFileViewer = () => {
        setShowFileViewer(false);
        setViewerUrl(null);
        setSelectedFile(null);
    };

    const handleUploadDialogFileRemove = async (file: any) => {
        if (!displayUploadAttachmentDialog?.agreementId) return;

        const targetId = file?.googleFileId || file?.fileId || file?.id || null;

        setUploadDialogAttachedFiles(prev => prev.filter(f => {
            const fId = f.googleFileId || f.fileId || f.id || null;
            return fId !== targetId;
        }));
    };

    const handleSaveUploadDialogMetadata = async () => {
        if (!displayUploadAttachmentDialog?.agreementId) return;
        try {
            setUploadingAttachment(true);

            let valid = true;
            let errorMessage = '';

            // Validate Hình thức cho từng hạng mục (giống logic ở màn hình tạo tài liệu)
            if (Array.isArray(uploadDialogDocumentTypeItems) && uploadDialogDocumentTypeItems.length > 0) {
                const missingMethod: string[] = [];
                uploadDialogDocumentTypeItems.forEach((item: any, idx: number) => {
                    const seq = resolveConfigItemSeq(item, idx);
                    if (!seq) return;
                    const seqKey = String(seq);

                    const isRequired = item?.isRequire === 'Y' || item?.isRequired === true || item?.required === true;
                    const hasFile = uploadDialogAttachedFiles.some((f: any) => {
                        const fileSeq = f?.sequenceNum ?? f?.configSequenceNum;
                        return Number(fileSeq) === Number(seq);
                    });

                    // Bỏ qua nếu không bắt buộc và chưa có file
                    if (!isRequired && !hasFile) return;

                    const meta = uploadDialogDocumentTypeItemMeta[seqKey];
                    if (!meta?.formType) {
                        const desc = item?.description || item?.fileTypeName || `Hạng mục #${seq}`;
                        missingMethod.push(desc);
                    }
                });

                if (missingMethod.length > 0) {
                    valid = false;
                    errorMessage = `Vui lòng chọn Hình thức cho: ${missingMethod.join(', ')}`;
                }
            }

            // Validate Ngày nhận cho các hạng mục có Hình thức = ATTACH_SCAN
            if (valid && Array.isArray(uploadDialogDocumentTypeItems) && uploadDialogDocumentTypeItems.length > 0) {
                const missingDateItems: string[] = [];
                uploadDialogDocumentTypeItems.forEach((item: any, idx: number) => {
                    const seq = resolveConfigItemSeq(item, idx);
                    if (!seq) return;
                    const seqKey = String(seq);

                    const meta = uploadDialogDocumentTypeItemMeta[seqKey];
                    const file = uploadDialogAttachedFiles.find((f: any) => {
                        const fileSeq = f?.sequenceNum ?? f?.configSequenceNum;
                        return Number(fileSeq) === Number(seq);
                    });

                    const normalizedFormType =
                        meta?.formType ??
                        (file?.agreementFormTypeEnumId ? normalizeFormTypeValue(file.agreementFormTypeEnumId) : null);

                    if (normalizedFormType === 'ATTACH_SCAN') {
                        const effectiveDateValue =
                            meta?.receivedDate ??
                            (file?.agreementFormDate ? new Date(file.agreementFormDate) : null);
                        if (!effectiveDateValue) {
                            const desc = item?.description || item?.fileTypeName || `Hạng mục #${seq}`;
                            missingDateItems.push(desc);
                        }
                    }
                });

                if (missingDateItems.length > 0) {
                    valid = false;
                    errorMessage = `Vui lòng nhập Ngày nhận cho: ${missingDateItems.join(', ')}`;
                }
            }

            // Validate bắt buộc phải có file cho các hạng mục required
            if (valid && Array.isArray(uploadDialogDocumentTypeItems) && uploadDialogDocumentTypeItems.length > 0) {
                const requiredItems = uploadDialogDocumentTypeItems.filter((item: any) => {
                    const flag = item?.isRequire ?? item?.isRequired ?? item?.required;
                    return flag === 'Y' || flag === true;
                });

                if (requiredItems.length > 0) {
                    const missingDescriptions: string[] = [];
                    requiredItems.forEach((item: any, idx: number) => {
                        const seq = resolveConfigItemSeq(item, idx);
                        if (!seq) return;
                        const hasFile = uploadDialogAttachedFiles.some((file: any) => {
                            const fileSeq = file?.sequenceNum ?? file?.configSequenceNum;
                            return Number(fileSeq) === Number(seq);
                        });
                        if (!hasFile) {
                            const desc = item?.description || item?.fileTypeName || `Hạng mục #${seq}`;
                            missingDescriptions.push(desc);
                        }
                    });

                    if (missingDescriptions.length > 0) {
                        valid = false;
                        errorMessage = `Vui lòng tải lên các tệp bắt buộc: ${missingDescriptions.join(', ')}`;
                    }
                }
            }

            if (!valid) {
                if (errorMessage) {
                    ToastService.error(errorMessage);
                }
                return;
            }

            const formatDateForAPI = (date: Date | null) => {
                if (!date) return undefined;
                const d = new Date(date);
                const year = d.getFullYear();
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                const hours = String(d.getHours()).padStart(2, '0');
                const minutes = String(d.getMinutes()).padStart(2, '0');
                const seconds = String(d.getSeconds()).padStart(2, '0');
                return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
            };

            const attachFile = uploadDialogAttachedFiles
                .filter(file => file.sequenceNum !== null && file.sequenceNum !== undefined)
                .map(file => {
                    const seqKey = String(file.sequenceNum);
                    const meta = uploadDialogDocumentTypeItemMeta[seqKey] || {};
                    const selectedFormType = meta?.formType ?? normalizeFormTypeValue(file.agreementFormTypeEnumId) ?? null;
                    const receivedDateValue = meta?.receivedDate ?? (file.agreementFormDate ? new Date(file.agreementFormDate) : null);
                    return {
                        agreementContentId: file.agreementContentId,
                        sequenceNum: file.sequenceNum,
                        fileId: file.googleFileId || file.fileId || file.id,
                        fileName: file.name,
                        receivedDate: receivedDateValue ? formatDateForAPI(receivedDateValue) : undefined,
                        agreementFormTypeEnumId: selectedFormType || file.agreementFormTypeEnumId || null,
                        agreementFormDate: receivedDateValue ? formatDateForAPI(receivedDateValue) : (file.agreementFormDate ? formatDateForAPI(new Date(file.agreementFormDate)) : undefined),
                        referenceFileId: file.referenceFileId
                    };
                });

            const res = await AgreementService.updateAgreementFiles(displayUploadAttachmentDialog.agreementId, { attachFile });
            if (res && res.success === 'Y') {
                ToastService.success('Cập nhật file đính kèm thành công');
                setDisplayUploadAttachmentDialog(null);
                reloadLazyData();
            } else {
                ToastService.error(res?.error || 'Không thể cập nhật file đính kèm');
            }
        } catch (error: any) {
            ToastService.error(error?.message || 'Có lỗi khi cập nhật file đính kèm');
        } finally {
            setUploadingAttachment(false);
        }
    };

    const handleCreateSubmit = async () => {
        setValidationTriggered(true);
        if (!validateStep0()) {
            setCreateStep(0 + stepOffset);
            return;
        }

        if (!validateStep1()) {
            setCreateStep(1 + stepOffset);
            return;
        }

        const missingSignerPositions = documentRecipients.filter(s => {
            const internalId = s._internalId;
            return !signaturePositions.some(p => String(p.internalRecipientId) === String(internalId));
        });
        
        if (missingSignerPositions.length > 0) {
            const missingNames = missingSignerPositions
                .map(s => s.party?.label || s.partyName || 'Chưa chọn đối tượng')
                .join(', ');
            ToastService.error(`Vui lòng thêm vị trí ký cho: ${missingNames}`);
            setCreateStep(2 + stepOffset);
            return;
        }

        setCreatingAgreement(true);
        try {
            const normalizedPositions = normalizeLocationSeq(signaturePositions);

            const mainFilesArray = mainFiles.map(file => ({
                fileName: file.name,
                fileId: file.googleFileId || file.fileId || file.id,
                contentType: file.type,
                contentLocation: file.googleFileUrl || file.contentLocation || undefined,
                referenceFileId: file.referenceFileId,
                isMainFile: 'Y'
            }));

            const attachmentFilesArray = attachedFiles.map(file => {
                const seqKey = String(file.sequenceNum || file.configSequenceNum);
                const meta = documentTypeItemMeta[seqKey] || {};
                return {
                    fileName: file.name,
                    fileId: file.googleFileId || file.fileId || file.id,
                    contentType: file.type,
                    contentLocation: file.googleFileUrl || file.contentLocation || undefined,
                    sequenceNum: file.sequenceNum || file.configSequenceNum,
                    agreementFormTypeEnumId: meta.formType || file.agreementFormTypeEnumId || null,
                    agreementFormDate: meta.receivedDate ? formatDateForAPI(new Date(meta.receivedDate)) : undefined,
                    referenceFileId: file.referenceFileId,
                    isMainFile: 'N'
                };
            });

            const agreementPartiesArray = documentRecipients.map((rec: any) => ({
                partyId: rec.partyId || rec.party?.partyId || rec.party?.value,
                roleTypeId: rec.roleTypeId,
                statusId: 'AGT_PTY_UNSIGNED'
            }));

            const positions = normalizedPositions.map(pos => {
                const internalId = pos.internalRecipientId;
                const recipient = documentRecipients.find((r: any) => r._internalId === internalId);
                const partyId = recipient?.partyId || pos.partyId;

                // Đảm bảo fileId hợp lệ, nếu thiếu hoặc là ID tạm thời thì lấy từ file chính đang active
                let finalFileId = pos.fileId;
                if (!finalFileId || String(finalFileId).startsWith('temp-')) {
                    const primaryFile = mainFiles[activeMainFileIndex] || mainFiles[0];
                    finalFileId = primaryFile?.googleFileId || primaryFile?.fileId || primaryFile?.id || null;
                }

                return {
                    locationSeqId: pos.locationSeqId,
                    partyId: partyId,
                    roleTypeId: pos.roleTypeId || recipient?.roleTypeId || null,
                    signatureTypeEnumId: pos.signatureTypeEnumId,
                    pageNumber: (pos.pageIndex || 0) + 1,
                    pageWidth: pageCanvases[pos.pageIndex]?.width || 0,
                    pageHeight: pageCanvases[pos.pageIndex]?.height || 0,
                    widthPx: pos.widthPx || 200,
                    heightPx: pos.heightPx || 65,
                    ulx: pos.x,
                    uly: pos.y,
                    fontSize: pos.fontSize || 12,
                    partyName: recipient?.partyName || pos.partyName || '',
                    identityCard: recipient?.identityCard || '',
                    emailAddress: recipient?.emailAddress || '',
                    taxCode: recipient?.taxCode || '',
                    contactNumber: recipient?.contactNumber || '',
                    representativeName: recipient?.representativeName || '',
                    fileId: finalFileId
                };
            });

            const signatureData = {
                agreementName: createFormData.agreementName,
                agreementNo: createFormData.agreementNo || undefined,
                agreementNoInt: createFormData.agreementNoInt || undefined,
                agreementNoFormatEnumId: createFormData.agreementNoFormatEnumId || undefined,
                agreementConfigureEnumId: createFormData.agreementType || createFormData.agreementConfigureEnumId,
                description: createFormData.description || undefined,
                fromDate: formatDateForAPI(createFormData.effectiveDate),
                thruDate: formatDateForAPI(createFormData.expiryDate),
                isImportant: createFormData.isImportant ? 'Y' : 'N',
                isUrgent: createFormData.isUrgent ? 'Y' : 'N',
                templateAgreementId: isCreatingFromTemplate ? selectedTemplateData?.agreementId : undefined,
                mainFiles: mainFilesArray,
                attachmentFiles: attachmentFilesArray,
                agreementParties: agreementPartiesArray,
                signaturePositions: positions
            };

            const res = await AgreementService.create(signatureData);

            if (res && res.success === 'Y' && res.agreementId) {
                ToastService.success('Tạo tài liệu thành công');
                setDisplayCreateDialog(false);
                setActiveTabIndex(0);
                try {
                    if (typeof window !== 'undefined' && window.localStorage) {
                        window.localStorage.setItem('econtract.taiLieuKy.activeTab', '0');
                    }
                } catch (e) {}
                reloadLazyData();
            } else {
                ToastService.error(res?.error || 'Không thể tạo tài liệu');
            }
        } catch (e: any) {
            ToastService.error('Có lỗi khi tạo tài liệu: ' + (e.message || 'Lỗi hệ thống'));
        } finally {
            setCreatingAgreement(false);
        }
    };

    const validateStep0 = () => {
        const hasType = createFormData.agreementType || createFormData.agreementConfigureEnumId;
        if (!createFormData.agreementName) {
            ToastService.error('Vui lòng nhập Tên tài liệu');
            return false;
        }
        if (!hasType) {
            ToastService.error('Vui lòng chọn Loại tài liệu');
            return false;
        }
        if (!createFormData.agreementNo) {
            ToastService.error('Vui lòng nhập Mã tài liệu');
            return false;
        }
        if (mainFiles.length === 0) {
            ToastService.error('Vui lòng tải lên tệp tài liệu chính');
            return false;
        }

        // Validate attached files
        if (Array.isArray(documentTypeItems) && documentTypeItems.length > 0) {
            const missingMethod: string[] = [];
            const missingDateItems: string[] = [];
            const missingFiles: string[] = [];

            documentTypeItems.forEach((item: any, idx: number) => {
                const seq = resolveConfigItemSeq(item, idx);
                if (!seq) return;
                const seqKey = String(seq);
                const isRequired = item?.isRequire === 'Y' || item?.isRequired === true || item?.required === true;
                
                const file = attachedFiles.find((f: any) => {
                    const fileSeq = f?.sequenceNum ?? f?.configSequenceNum;
                    return Number(fileSeq) === Number(seq);
                });

                // 1. Check if required file is missing
                if (isRequired && !file) {
                    missingFiles.push(item?.description || item?.fileTypeName || `Hạng mục #${seq}`);
                }

                // 2. Check if Form Type is missing (for required item or item with file)
                if (isRequired || file) {
                    const meta = documentTypeItemMeta[seqKey];
                    const normalizedFormType = meta?.formType ?? (file?.agreementFormTypeEnumId ? normalizeFormTypeValue(file.agreementFormTypeEnumId) : null);
                    
                    if (!normalizedFormType) {
                        missingMethod.push(item?.description || item?.fileTypeName || `Hạng mục #${seq}`);
                    } else if (normalizedFormType === 'ATTACH_SCAN') {
                        // 3. Check if Received Date is missing for ATTACH_SCAN
                        const effectiveDateValue = meta?.receivedDate ?? (file?.agreementFormDate ? new Date(file.agreementFormDate) : null);
                        if (!effectiveDateValue) {
                            missingDateItems.push(item?.description || item?.fileTypeName || `Hạng mục #${seq}`);
                        }
                    }
                }
            });

            if (missingFiles.length > 0) {
                ToastService.error(`Vui lòng tải lên các tệp bắt buộc: ${missingFiles.join(', ')}`);
                return false;
            }
            if (missingMethod.length > 0) {
                ToastService.error(`Vui lòng chọn Hình thức cho: ${missingMethod.join(', ')}`);
                return false;
            }
            if (missingDateItems.length > 0) {
                ToastService.error(`Vui lòng nhập Ngày nhận cho: ${missingDateItems.join(', ')}`);
                return false;
            }
        }
        return true;
    };

    const validateStep1 = () => {
        let checker = true;
        let errorMessage = '';

        for (let i = 0; i < documentRecipients.length; i++) {
            const item = documentRecipients[i];

            if (!item.party?.label && !item.partyId) {
                checker = false;
                errorMessage = 'Chưa chọn đối tượng ký';
                break;
            }

            if (!item.emailAddress) {
                checker = false;
                errorMessage = `Chưa nhập địa chỉ email cho ${item.partyName || item.party?.label}`;
                break;
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(item.emailAddress)) {
                checker = false;
                errorMessage = `Địa chỉ email của ${item.partyName || item.party?.label} chưa nhập đúng định dạng`;
                break;
            }

            if (!item.roleTypeId) {
                checker = false;
                errorMessage = `Chưa chọn vai trò người ký cho ${item.partyName || item.party?.label}`;
                break;
            }

            const trimmedtaxCode = item.taxCode?.trim() || '';
            const taxCodeRegex = /^(\d{10}|\d{12}|\d{13}|\d{10}-\d{3})$/;
            if (trimmedtaxCode.length > 0 && !taxCodeRegex.test(trimmedtaxCode)) {
                checker = false;
                errorMessage = `Mã số thuế của ${item.partyName || item.party?.label} phải có 10, 12, 13 số `;
                break;
            }

            const trimmedContactNumber = item.contactNumber?.trim() || '';
            if (trimmedContactNumber.length > 0 && trimmedContactNumber.length !== 10) {
                checker = false;
                errorMessage = `Số điện thoại của ${item.partyName || item.party?.label} phải có đúng 10 số`;
                break;
            }

            const trimmedIdentityCard = item.identityCard?.trim() || '';
            if (trimmedIdentityCard.length > 0 && ![9, 12].includes(trimmedIdentityCard.length)) {
                checker = false;
                errorMessage = `CCCD/CMND của ${item.partyName || item.party?.label} phải có 9 hoặc 12 số`;
                break;
            }
        }

        if (!checker && errorMessage) {
            ToastService.error(errorMessage);
        }

        return checker;
    };

    const nextStep = async () => {
        setValidationTriggered(true);

        // Step "Điền thông tin" (chỉ khi có mẫu) - Luôn là index 0
        if (hasTemplateFields && createStep === 0) {
            if (selectedTemplateData && templateFormFields.length > 0) {
                const success = await handleFillTemplateConfirm();
                if (!success) return;
            }
        }

        // Validate "Thông tin & Tệp" - Luôn là index 0 + stepOffset
        if (createStep === (0 + stepOffset)) {
            if (!validateStep0()) return;
        }

        // Validate "Người ký" - Luôn là index 1 + stepOffset
        if (createStep === (1 + stepOffset)) {
            if (!validateStep1()) return;
            
            // Kiểm tra PDF nếu sắp sang Bước 3
            const mainFile = mainFiles[0];
            if (mainFile && mainFile.extension !== 'pdf' && !mainFile.referenceFileId && pdfGenerating.has(mainFile.fileId)) {
                ToastService.success('Bản xem trước đang được xử lý, vui lòng đợi xíu nha!');
                // Cho phép đi tiếp nhưng Step3 sẽ hiện loading
            }
        }
        
        const next = createStep + 1;
        setCreateStep(next);
        setMaxStepReached(prev => Math.max(prev, next));
    };

    const prevStep = () => setCreateStep(prev => prev - 1);

    const goToStep = (index: number) => {
        if (index === createStep) return;
        
        // If going forward, validate steps up to target
        if (index > createStep) {
            setValidationTriggered(true);
            for (let i = createStep; i < index; i++) {
                if (i === (0 + stepOffset) && !validateStep0()) return;
                if (i === (1 + stepOffset) && !validateStep1()) return;
            }
        } else {
            // Going back doesn't trigger validation highlight for the current step
            // But we keep setValidationTriggered(false) or true depending on preference.
            // Usually going back is fine.
            setValidationTriggered(false);
        }

        if (index <= maxStepReached || index < createStep) {
            setCreateStep(index);
        }
    };

    // Helpers for Step progress (matching tai-lieu/index.tsx)
    const renderStepIndicators = () => {
        const connectorStyle = {
            width: '80px',
            maxWidth: '120px',
            height: '2px',
            margin: '0 8px'
        } as React.CSSProperties;

        const isUnlocked = (index: number) => index <= maxStepReached;

        return (
            <div className="flex align-items-center justify-content-center flex-1" style={{ gap: '12px' }}>
                {createStepsItems.map((step, idx) => (
                    <React.Fragment key={idx}>
                        {idx > 0 && (
                            <div className={`border-top-1 ${createStep >= idx ? 'border-primary' : 'border-300'}`} style={connectorStyle}></div>
                        )}
                        <div
                            className={`flex align-items-center ${isUnlocked(idx) ? 'cursor-pointer' : ''}`}
                            style={{ gap: '8px' }}
                            onClick={() => goToStep(idx)}
                        >
                            <div
                                className={`flex align-items-center justify-content-center border-circle ${createStep >= idx ? 'bg-primary text-white font-bold' : 'border-2 text-400'}`}
                                style={{
                                    width: '32px',
                                    height: '32px',
                                    fontSize: '14px',
                                    backgroundColor: createStep >= idx ? 'var(--primary-color)' : 'var(--surface-card)',
                                    borderColor: createStep >= idx ? 'var(--primary-color)' : 'var(--surface-border)',
                                    color: createStep >= idx ? 'var(--primary-color-text)' : 'var(--text-color-secondary)'
                                }}
                            >
                                {idx + 1}
                            </div>
                            <span
                                className={`text-sm ${createStep === idx ? 'font-bold' : 'font-medium'}`}
                                style={{ whiteSpace: 'nowrap', color: createStep >= idx ? 'var(--text-color)' : 'var(--text-color-secondary)' }}
                            >
                                {step.label}
                            </span>
                        </div>
                    </React.Fragment>
                ))}
            </div>
        );
    };

    const renderProgressSteps = () => (
        <div className="px-4 py-3 border-bottom-1 surface-border surface-card" style={{ zIndex: 10 }}>
            <div className="flex align-items-center justify-content-between" style={{ gap: '12px' }}>
                <Button label="Hủy" icon="pi pi-times" className="p-button-text p-button-secondary" onClick={() => setDisplayCreateDialog(false)} />
                {renderStepIndicators()}
                <div className="flex gap-2">
                    {createStep > 0 && <Button label="Quay lại" icon="pi pi-arrow-left" className="p-button-outlined p-button-secondary" onClick={prevStep} />}
                    {createStep < createStepsItems.length - 1 ? (
                        <Button 
                            label="Tiếp theo" 
                            icon="pi pi-arrow-right" 
                            onClick={nextStep} 
                            className="p-button-primary" 
                            loading={fillingTemplate || (createStep === (1 + stepOffset) && mainFiles[0] && pdfGenerating.has(mainFiles[0].fileId))} 
                        />
                    ) : (
                        <Button label="Hoàn tất" icon="pi pi-check" severity="success" onClick={handleCreateSubmit} loading={creatingAgreement} />
                    )}
                </div>
            </div>
        </div>
    );

    return (
        <div className="card border-none shadow-1 border-round-xl" style={{ backgroundColor: 'var(--surface-ground)' }}>
            <style dangerouslySetInnerHTML={{
                __html: `
                .tai-lieu-ky-table .p-datatable-thead > tr:nth-child(2) > th {
                    position: sticky !important;
                    top: 38px !important;
                    z-index: 9 !important;
                    background: var(--surface-card) !important;
                }
                .tai-lieu-ky-table .p-datatable-thead > tr:first-child > th {
                    position: sticky !important;
                    top: 0 !important;
                    z-index: 10 !important;
                    background: var(--surface-card) !important;
                }
            `}} />
            <div className="col-12">
                <h3 className="m-0 mb-2" style={{ color: 'var(--text-color)', fontWeight: 'bold' }}>Quản lý tài liệu</h3>
            </div>
            <div className="col-12 pb-0 relative">
                <div className="flex gap-2 absolute right-0 top-0 z-5 mr-3 mt-1">
                    <Button
                        label="Tải lên Excel"
                        icon="pi pi-upload"
                        className="p-button-success p-button-sm"
                        onClick={() => setDisplayBulkUploadDialog(true)}
                    />
                    <Button label="Tạo từ mẫu" icon="pi pi-copy" className="p-button-outlined p-button-sm" onClick={() => setShowTemplateDialog(true)} />
                    <Button label="Tạo tài liệu" icon="pi pi-plus" className="p-button-primary p-button-sm" onClick={() => openCreateDialog(false)} />
                </div>
                <Toast ref={toast} />
                <TabView activeIndex={activeTabIndex} onTabChange={handleTabChange}>
                    <TabPanel header="Tài liệu nháp">
                        <DraftTab
                            handleView={handleView}
                            handleSign={handleSign}
                            handleSignFromDraft={handleSignFromDraft}
                            handleSendEmail={handleSendEmail}
                            handleEdit={handleEdit}
                            handleDelete={handleDelete}
                            handleShowFiles={handleShowFiles}
                            sendingEmail={sendingEmail}
                            setReload={(fn) => reloadDraftRef.current = fn}
                            handleBulkSign={handleBulkSign}
                        />
                    </TabPanel>
                    <TabPanel header="Đang xử lý">
                        <InProgressTab
                            handleShowFiles={handleShowFiles}
                            handleSign={handleSign}
                            handleSendEmail={handleSendEmail}
                            handleCancel={handleCancel}
                            handleConvertToDraft={handleConvertToDraft}
                            loadCanvas={openPdfInNewTab}
                            setDisplayUploadAttachmentDialog={setDisplayUploadAttachmentDialog}
                            isSigning={isSigning}
                            sendingEmail={sendingEmail}
                            headerResult={headerResult}
                            setReload={(fn) => reloadInProgressRef.current = fn}
                            handleBulkSign={handleBulkSign}
                        />
                    </TabPanel>
                    <TabPanel header="Hoàn thành">
                        <CompletedTab
                            handleCancel={handleCancel}
                            handleShowFiles={handleShowFiles}
                            loadCanvas={openPdfInNewTab}
                            setDisplayUploadAttachmentDialog={setDisplayUploadAttachmentDialog}
                            isSigning={isSigning}
                            headerResult={headerResult}
                            setReload={(fn) => reloadCompletedRef.current = fn}
                        />
                    </TabPanel>
                    <TabPanel header="Đã hủy">
                        <CancelledTab
                            loadCanvas={openPdfInNewTab}
                            handleShowFiles={handleShowFiles}
                            headerResult={headerResult}
                            setReload={(fn) => reloadCancelledRef.current = fn}
                        />
                    </TabPanel>
                    <TabPanel header="Thùng rác">
                        <TrashTab
                            handleView={handleView}
                            handleRestore={handleRestore}
                            handleShowFiles={handleShowFiles}
                            headerResult={headerResult}
                            setReload={(fn) => reloadTrashRef.current = fn}
                        />
                    </TabPanel>
                </TabView>
            </div>
            <UploadExcel display={displayUploadExcel} setDisplay={setDisplayUploadExcel} reloadLazyData={reloadLazyData} agreementId={displayUploadAttachmentDialog?.agreementId} />
            <Dialog header="Chọn đối tượng ký" visible={!!displaySignerDialog} style={{ width: '70rem' }} onHide={() => setDisplaySignerDialog(null)}
                footer={(
                    <div className="flex justify-content-end gap-2">
                        <Button label="Ký" icon="pi pi-check" className="p-button-success p-button-sm" disabled={isSigning} onClick={submitSignSelected} />
                        <Button label="Đóng" icon="pi pi-times" className="p-button-outlined p-button-secondary p-button-sm" disabled={isSigning} onClick={() => setDisplaySignerDialog(null)} />
                    </div>
                )}
            >
                {renderSignerTable()}
            </Dialog>

            {/* Email dialog */}
            <Dialog
                header="Chọn đối tượng gửi email"
                visible={!!displayEmailDialog}
                style={{ width: '70rem' }}
                onHide={() => {
                    setDisplayEmailDialog(null);
                    setEmailParties([]);
                }}
                footer={(
                    <div className="flex justify-content-end gap-2">
                        <Button
                            label="Gửi email"
                            icon="pi pi-send"
                            className="p-button-success p-button-sm"
                            disabled={sendingEmail || emailParties.filter(p => p.checked).length === 0}
                            onClick={submitEmailSelected}
                            loading={sendingEmail}
                        />
                        <Button
                            label="Đóng"
                            icon="pi pi-times"
                            className="p-button-outlined p-button-secondary p-button-sm"
                            disabled={sendingEmail}
                            onClick={() => {
                                setDisplayEmailDialog(null);
                                setEmailParties([]);
                            }}
                        />
                    </div>
                )}
            >
                {renderEmailTable()}
            </Dialog>

            {/* Loading dialog while signing */}
            <Dialog header={null} visible={isSigning} modal closable={false} closeOnEscape={false} dismissableMask={false} style={{ width: '36rem' }} onHide={() => { }}>
                <div className="flex flex-column align-items-center justify-content-center py-6">
                    <i className="pi pi-spin pi-spinner mb-4" style={{ fontSize: '3rem', color: '#3B82F6' }} />
                    <div className="text-center" style={{ fontWeight: 700, fontSize: '1.75rem', color: '#3B82F6' }}>Đang ký xác thực...</div>
                </div>
            </Dialog>

            {/* Bulk Signing Loading Dialog */}
            <Dialog header={null} visible={isBulkSigning} modal closable={false} closeOnEscape={false} dismissableMask={false} style={{ width: '36rem' }} onHide={() => { }}>
                <div className="flex flex-column align-items-center justify-content-center py-6">
                    <i className="pi pi-spin pi-spinner mb-4" style={{ fontSize: '3rem', color: '#3B82F6' }} />
                    <div className="text-center mb-2" style={{ fontWeight: 700, fontSize: '1.75rem', color: '#3B82F6' }}>Đang ký hàng loạt...</div>
                    <div className="text-center text-xl text-600">
                        Tiến độ: {bulkSignProgress.current} / {bulkSignProgress.total} tài liệu
                    </div>
                </div>
            </Dialog>

            {/* Cancel confirmation dialog */}
            <Dialog
                header="Xác nhận hủy tài liệu"
                visible={!!cancelDialog}
                style={{ width: '32rem' }}
                onHide={() => {
                    setCancelDialog(null);
                    setCancelReason('');
                }}
                footer={
                    <div className="flex justify-content-end gap-2">
                        <Button
                            label="Hủy"
                            icon="pi pi-times"
                            className="p-button-outlined p-button-secondary p-button-sm"
                            onClick={() => {
                                setCancelDialog(null);
                                setCancelReason('');
                            }}
                        />
                        <Button
                            label="Xác nhận"
                            icon="pi pi-check"
                            className="p-button-danger p-button-sm"
                            onClick={confirmCancel}
                        />
                    </div>
                }
            >
                <div className="flex flex-column gap-3">
                    <div className="flex align-items-center gap-3">
                        <i className="pi pi-exclamation-triangle text-3xl text-orange-500" />
                        <div>
                            <p className="m-0 mb-2">Bạn có chắc muốn hủy tài liệu này?</p>
                            {cancelDialog?.agreementName && (
                                <p className="m-0 text-sm text-gray-600 font-medium">{cancelDialog.agreementName}</p>
                            )}
                        </div>
                    </div>
                    <div className="field">
                        <label htmlFor="cancelReason" className="block text-900 font-medium mb-2">
                            Lý do hủy <span className="text-red-500">(*)</span>
                        </label>
                        <InputTextarea
                            id="cancelReason"
                            value={cancelReason}
                            onChange={(e) => setCancelReason(e.target.value)}
                            rows={4}
                            className="w-full"
                            placeholder="Nhập lý do hủy tài liệu..."
                            autoFocus
                        />
                    </div>
                </div>
            </Dialog>

            {/* File viewer dialog */}
            <Dialog
                header={<span className="font-semibold text-lg">{selectedFile?.name || selectedFile?.fileName || 'Xem tài liệu'}</span>}
                visible={showFileViewer}
                style={{ width: '98vw', height: '95vh' }}
                contentClassName="p-0 flex flex-column"
                maximizable
                onHide={() => {
                    setShowFileViewer(false);
                    setViewerUrl(null);
                    setSelectedFile(null);
                    setCurrentPage(1);
                }}
                footer={
                    <div className="flex justify-content-end">
                        <Button label="Đóng" icon="pi pi-times" onClick={closeFileViewer} className="p-button-text" />
                    </div>
                }
            >
                {viewerUrl && (
                    <PdfCanvasViewer 
                        fileId={viewerUrl} 
                        fileName={viewerFileName}
                        scale={2.0} 
                        currentPage={currentPage} 
                        onPageChange={setCurrentPage} 
                    />
                )}
            </Dialog>

            {/* File list dialog */}
            <Dialog
                header={`Danh sách file - ${displayFileDialog?.agreementName || ''}`}
                visible={!!displayFileDialog}
                maximized={true}
                draggable={false}
                style={{ width: '95vw', height: '90vh', maxWidth: 'none' }}
                contentClassName="p-0 flex flex-column"
                onHide={closeFileDialog}
                footer={
                    <div className="flex justify-content-end gap-2">
                        <Button
                            label="Đóng"
                            icon="pi pi-times"
                            className="p-button-outlined p-button-secondary p-button-sm"
                            onClick={closeFileDialog}
                        />
                    </div>
                }
            >
                {(fileDialogMainFiles.length > 0 || fileDialogAttachmentFiles.length > 0) ? (
                    <TabView activeIndex={fileDialogActiveTabIndex} onTabChange={(e) => setFileDialogActiveTabIndex(e.index)}>
                        <TabPanel header={`File chính${fileDialogMainFiles.length > 0 ? ` (${fileDialogMainFiles.length})` : ''}`}>
                            {fileDialogMainFiles.length > 0 ? (
                                <div className="flex flex-column gap-2">
                                    {fileDialogMainFiles.map((file, index) => (
                                        <div key={file.agreementContentId || index} className="flex align-items-center justify-content-between p-2 border-1 surface-border border-round">
                                            <span>{file.fileName || `File chính ${index + 1}`}</span>
                                            <Button
                                                label="Xem"
                                                icon="pi pi-eye"
                                                className="p-button-sm p-button-outlined"
                                                onClick={() => openPdfInNewTab(file)}
                                            />
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div style={{ padding: '2rem', textAlign: 'center' }}>
                                    <p>Không tìm thấy file ký số để hiển thị.</p>
                                </div>
                            )}
                        </TabPanel>

                        {fileDialogAttachmentFiles.length > 0 && (
                            <TabPanel header={`File đính kèm (${fileDialogAttachmentFiles.length})`}>
                                {fileDialogAttachmentFiles.length > 0 ? (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', height: '90%', overflow: 'auto' }}>
                                        {fileDialogAttachmentFiles.map((file, index) => {
                                            return (
                                                <div key={file.agreementContentId || index} style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '1rem' }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0' }}>
                                                        <div>
                                                            <strong>{file.fileName || `File đính kèm ${index + 1}`}</strong>
                                                            {file.sequenceNum && <span style={{ marginLeft: '0.5rem', color: '#666' }}>(Thứ tự: {file.sequenceNum})</span>}
                                                        </div>
                                                        <div>
                                                            <Button
                                                                label="Xem"
                                                                icon="pi pi-eye"
                                                                className="p-button-sm p-button-outlined"
                                                                onClick={() => openPdfInNewTab(file)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div style={{ padding: '2rem', textAlign: 'center' }}>
                                        <p>Chưa có file đính kèm</p>
                                    </div>
                                )}
                            </TabPanel>
                        )}
                    </TabView>
                ) : (
                    <div style={{ padding: '2rem', textAlign: 'center' }}>
                        <p>Không tìm thấy file để hiển thị.</p>
                    </div>
                )}
            </Dialog>

            {/* Upload attachment dialog */}
            <Dialog
                header={`${displayUploadAttachmentDialog?.agreementName || ''}`}
                visible={!!displayUploadAttachmentDialog}
                style={{ width: '95vw', maxWidth: '1200px' }}
                onHide={() => {
                    setDisplayUploadAttachmentDialog(null);
                    setUploadDialogDocumentTypeItems([]);
                    setUploadDialogDocumentTypeItemMeta({});
                    setUploadDialogAttachedFiles([]);
                    setUploadDialogAgreementType(null);
                }}
                footer={
                    <div className="flex justify-content-end gap-2">
                        <Button
                            label="Đóng"
                            icon="pi pi-times"
                            className="p-button-outlined p-button-secondary p-button-sm"
                            disabled={uploadingAttachment}
                            onClick={() => {
                                setDisplayUploadAttachmentDialog(null);
                                setUploadDialogDocumentTypeItems([]);
                                setUploadDialogDocumentTypeItemMeta({});
                                setUploadDialogAttachedFiles([]);
                                setUploadDialogAgreementType(null);
                            }}
                        />
                        <Button
                            label="Lưu"
                            icon="pi pi-check"
                            className="p-button-success p-button-sm"
                            disabled={uploadingAttachment}
                            onClick={handleSaveUploadDialogMetadata}
                        />
                    </div>
                }
            >
                <div className="flex flex-column gap-3">
                    {uploadDialogDocumentTypeItemsLoading ? (
                        <div className="flex align-items-center gap-2 mt-1 text-sm text-blue-500">
                            <i className="pi pi-spin pi-spinner" />
                            <span>Đang tải cấu hình...</span>
                        </div>
                    ) : uploadDialogDocumentTypeItems.length > 0 ? (
                        <div className="border-2 border-dashed border-blue-200 border-round p-2 mt-3" style={{ overflowX: 'auto' }}>
                            <table className="w-full text-sm" style={{ tableLayout: 'fixed', minWidth: '900px' }}>
                                <thead>
                                    <tr className="text-left bg-blue-50">
                                        <th style={{ width: '50px' }} className="p-2 text-center">#</th>
                                        <th style={{ width: '260px' }} className="p-2">Mô tả tài liệu</th>
                                        <th style={{ width: '320px' }} className="p-2">Tệp tài liệu</th>
                                        <th style={{ width: '165px' }} className="p-2 text-center">Hình thức</th>
                                        <th style={{ width: '190px' }} className="p-2 text-center">Ngày nhận</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {uploadDialogDocumentTypeItems.map((item: any, idx: number) => {
                                        const seq = resolveConfigItemSeq(item, idx);
                                        const seqKey = seq ? String(seq) : `idx-${idx}`;
                                        const isRequired =
                                            (() => {
                                                const flag = item?.isRequire ?? item?.isRequired ?? item?.required;
                                                return flag === 'Y' || flag === true;
                                            })();
                                        const meta = uploadDialogDocumentTypeItemMeta[seqKey] || {};
                                        const formType = meta?.formType;
                                        const file = uploadDialogAttachedFiles.find((f: any) => {
                                            const fileSeq = f?.sequenceNum ?? f?.configSequenceNum;
                                            return Number(fileSeq) === Number(seq);
                                        });
                                        return (
                                            <tr key={seqKey} className="border-bottom-1 surface-border">
                                                <td className="p-2 text-center font-semibold" style={{ width: '50px' }}>
                                                    {seq ?? idx + 1}
                                                </td>
                                                <td className="p-2" style={{ width: '260px' }}>
                                                    <span
                                                        style={{
                                                            display: 'inline-block',
                                                            maxWidth: '100%',
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis'
                                                        }}
                                                        title={getFileTypeName(item)}
                                                    >
                                                        {getFileTypeName(item)}
                                                        {isRequired && <span className="text-red-500 ml-1">*</span>}
                                                    </span>
                                                </td>
                                                <td className="p-2" style={{ width: '320px' }}>
                                                    <div
                                                        className="flex align-items-center gap-2"
                                                        style={{ flexWrap: 'nowrap', width: '100%' }}
                                                    >
                                                        {!file && (
                                                            <Button
                                                                type="button"
                                                                label="Chọn tệp"
                                                                icon="pi pi-folder"
                                                                className="p-button-sm"
                                                                style={{ flexShrink: 0, minWidth: '100px' }}
                                                                onClick={() => handleUploadDialogItemUpload(item, idx)}
                                                                disabled={uploadingAttachment}
                                                            />
                                                        )}
                                                        <div className="flex flex-column flex-1 overflow-hidden" style={{ minWidth: 0 }}>
                                                            <span
                                                                className="text-gray-600 truncate block"
                                                                style={{
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis'
                                                                }}
                                                                title={file ? file.name : 'Không có tệp nào được chọn'}
                                                            >
                                                                {file ? file.name : 'Không có tệp nào được chọn'}
                                                            </span>
                                                        </div>
                                                        {file && (
                                                            <div className="flex align-items-center gap-1" style={{ flexShrink: 0 }}>
                                                                <div className="flex gap-1">
                                                                    <Menu
                                                                        model={getAttachmentMenuItems(file, handleUploadDialogFileRemove)}
                                                                        popup
                                                                        ref={(el) => { if (el) (file as any).uploadMenuRef = el; }}
                                                                    />
                                                                    <Button
                                                                        type="button"
                                                                        icon="pi pi-ellipsis-v"
                                                                        className="p-button-text p-button-secondary p-button-sm"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            (file as any).uploadMenuRef?.toggle(e);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td className="p-2 text-center" style={{ width: '165px' }}>
                                                    <Dropdown
                                                        value={meta?.formType ?? null}
                                                        options={uploadDialogFormTypeOptions}
                                                        optionLabel="label"
                                                        optionValue="value"
                                                        placeholder="Chọn"
                                                        className="w-full"
                                                        onChange={(e) => handleUploadDialogItemMetaChange(seqKey, 'formType', e.value)}
                                                        disabled={uploadingAttachment}
                                                    />
                                                </td>
                                                <td className="p-2 text-center" style={{ width: '190px' }}>
                                                    <Calendar
                                                        value={meta?.receivedDate ?? null}
                                                        onChange={(e) => handleUploadDialogItemMetaChange(seqKey, 'receivedDate', e.value)}
                                                        showIcon
                                                        dateFormat="dd/mm/yy"
                                                        placeholder="Chọn ngày"
                                                        className="w-full"
                                                        disabled={uploadingAttachment}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    ) : uploadDialogAttachedFiles.length > 0 ? (
                        <div className="border-2 border-dashed border-blue-200 border-round p-2 mt-3" style={{ overflowX: 'auto' }}>
                            <table className="w-full text-sm" style={{ tableLayout: 'fixed', minWidth: '700px' }}>
                                <thead>
                                    <tr className="text-left bg-blue-50">
                                        <th style={{ width: '60px' }} className="p-2 text-center">#</th>
                                        <th style={{ width: '360px' }} className="p-2">Tệp tài liệu</th>
                                        <th style={{ width: '160px' }} className="p-2 text-center">Hành động</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {uploadDialogAttachedFiles.map((file: any, idx: number) => (
                                        <tr key={file.agreementContentId || file.name || idx} className="border-bottom-1 surface-border">
                                            <td className="p-2 text-center font-semibold" style={{ width: '60px' }}>{idx + 1}</td>
                                            <td className="p-2" style={{ width: '360px' }}>
                                                <div className="flex flex-column flex-1 overflow-hidden">
                                                    <span
                                                        style={{
                                                            display: 'inline-block',
                                                            maxWidth: '100%',
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis'
                                                        }}
                                                        title={file.fileName || file.name}
                                                    >
                                                        {file.fileName || file.name}
                                                    </span>
                                                    {pdfGenerating.has(file.fileId || file.googleFileId || file.id) && (
                                                        <div className="flex align-items-center gap-1 text-xs text-blue-500 mt-1">
                                                            <i className="pi pi-spin pi-spinner" style={{ fontSize: '0.75rem' }} />
                                                            <span>Đang chuẩn bị...</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                            <td className="p-2 text-center" style={{ width: '160px' }}>
                                                <div className="flex justify-content-center gap-2">
                                                    <Button
                                                        type="button"
                                                        icon="pi pi-eye"
                                                        className="p-button-rounded p-button-text p-button-sm"
                                                        tooltip="Xem"
                                                        onClick={() => handleUploadDialogViewFile(file)}
                                                        disabled={uploadingAttachment}
                                                    />
                                                    <Button
                                                        type="button"
                                                        icon="pi pi-trash"
                                                        className="p-button-rounded p-button-text p-button-danger p-button-sm"
                                                        tooltip="Xóa"
                                                        onClick={() => handleUploadDialogFileRemove(file)}
                                                        disabled={uploadingAttachment}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="mt-1 text-sm text-gray-500">
                            Loại tài liệu này chưa có cấu hình file đính kèm.
                        </div>
                    )}
                    {uploadingAttachment && (
                        <div className="flex align-items-center gap-2">
                            <i className="pi pi-spin pi-spinner"></i>
                            <span>Đang xử lý...</span>
                        </div>
                    )}
                </div>
            </Dialog>


            <Dialog
                visible={displayCreateDialog}
                onHide={() => setDisplayCreateDialog(false)}
                style={{ width: '95vw', height: '95vh' }}
                maximized
                closable={false}
                className="agreement-creation-dialog"
                contentClassName="p-0 overflow-hidden"
            >
                <div className="flex flex-column h-full surface-section">
                    {renderProgressSteps()}
                    <div className={`flex-1 overflow-y-auto ${createStep === (2 + stepOffset) ? 'p-0' : 'p-4'}`}>
                        <div className={createStep === (2 + stepOffset) ? 'w-full h-full' : 'mx-auto'} style={createStep === (2 + stepOffset) ? { height: '100%' } : { maxWidth: '1600px' }}>
                            {hasTemplateFields && createStep === 0 && (
                                <div className="card shadow-2 border-round-xl p-4 surface-card">
                                    <h3 className="mt-0 mb-2">Điền thông tin vào mẫu tài liệu</h3>
                                    <p className="text-sm text-500 mt-0 mb-4">Vui lòng điền các thông tin bên dưới. Hệ thống sẽ tự động thay thế vào tài liệu mẫu.</p>
                                    <div className="grid">
                                        {[...templateFormFields].sort((a, b) => (Number(a.layoutSequenceNum) || 999) - (Number(b.layoutSequenceNum) || 999)).map((field: any) => {
                                            const fieldType = detectFieldType(field);
                                            const value = templateFieldValues[field.fieldName] ?? '';
                                            return (
                                                <div key={field.fieldName} className="col-12 md:col-6 field">
                                                    <label className="block text-900 font-medium mb-2">
                                                        {field.title || field.fieldName}
                                                        {(field.isRequired === 'Y' || field.isRequired === true) && <span className="text-red-500 ml-1">*</span>}
                                                    </label>
                                                    {fieldType === 'AgtFftDate' ? (
                                                        <Calendar
                                                            value={value || null}
                                                            onChange={e => setTemplateFieldValues(prev => ({ ...prev, [field.fieldName]: e.value }))}
                                                            dateFormat="dd/mm/yy"
                                                            showIcon
                                                            className="w-full"
                                                            placeholder={`Chọn ${field.title || field.fieldName}`}
                                                        />
                                                    ) : fieldType === 'AgtFftCheckbox' ? (
                                                        <div className="flex align-items-center mt-2">
                                                            <Checkbox
                                                                inputId={field.fieldName}
                                                                checked={value === 'YES' || value === true}
                                                                onChange={e => setTemplateFieldValues(prev => ({ ...prev, [field.fieldName]: e.checked ? 'YES' : 'NO' }))}
                                                            />
                                                            <label htmlFor={field.fieldName} className="ml-2 cursor-pointer font-normal text-600">Thực hiện</label>
                                                        </div>
                                                    ) : fieldType === 'AgtFftNumber' ? (
                                                        <InputNumber
                                                            value={typeof value === 'number' ? value : (parseFloat(String(value)) || null)}
                                                            onValueChange={e => setTemplateFieldValues(prev => ({ ...prev, [field.fieldName]: e.value }))}
                                                            className="w-full"
                                                            placeholder={`Nhập ${field.title || field.fieldName}`}
                                                            useGrouping={false}
                                                        />
                                                    ) : (
                                                        <InputText
                                                            value={value}
                                                            onChange={e => setTemplateFieldValues(prev => ({ ...prev, [field.fieldName]: e.target.value }))}
                                                            className="w-full"
                                                            placeholder={`Nhập ${field.title || field.fieldName}`}
                                                        />
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                            {createStep === (0 + stepOffset) && (
                                <Step1InfoAndFiles
                                    formData={createFormData} setFormData={setCreateFormData} documentTypes={agreementTypeOptions}
                                    mainFiles={mainFiles} attachedFiles={attachedFiles} documentTypeItems={documentTypeItems}
                                    documentTypeItemsLoading={documentTypeItemsLoading} documentTypeItemMeta={documentTypeItemMeta}
                                    formTypeOptions={formTypeOptions} filePreviews={filePreviews} previewLoading={previewLoading}
                                    onComputerUpload={handleComputerUpload} onCreateGoogleFile={handleCreateGoogleFile}
                                    onViewFile={handleViewFile}
                                    onRemoveFile={handleRemoveLocalFile}
                                    onItemUpload={handleDocumentTypeItemUpload}
                                    onItemMetaChange={handleDocumentTypeItemMetaChange}
                                    getFileMenuItems={getFileMenuItems}
                                    getAttachmentMenuItems={getAttachmentMenuItems}
                                    getIconByExtension={getIconByExtension}
                                    getFileTypeName={getFileTypeName}
                                    validationTriggered={validationTriggered}
                                    isTemplateMode={isCreatingFromTemplate}
                                    pdfGenerating={pdfGenerating}
                                    onAutoLoadTemplate={async (templateId: string) => {
                                        try {
                                            const detail = await AgreementTemplateService.get(templateId);
                                            if (detail) {
                                                setSelectedTemplateData(detail);
                                                setIsCreatingFromTemplate(true);
                                                
                                                // Lấy form fields
                                                const fieldsRes = await AgreementTemplateService.getFormFields(templateId);
                                                const fields = fieldsRes?.dbFormFields || fieldsRes?.listData || [];
                                                const finalFields = Array.isArray(fields) ? fields : [];
                                                setTemplateFormFields(finalFields);
                                                
                                                let newFileId = null;
                                                if (finalFields.length === 0) {
                                                    const fillRes = await AgreementService.fillPlaceholder({
                                                        templateAgreementId: templateId,
                                                        placeholders: {}
                                                    });
                                                    newFileId = fillRes?.fileId || fillRes?.googleFileId;
                                                }

                                                applyTemplateData(detail, newFileId);
                                                
                                                // Nếu có fields, nhảy về bước điền thông tin (step 0)
                                                if (finalFields.length > 0) {
                                                    setCreateStep(0);
                                                }
                                            }
                                        } catch (err) {
                                            console.error('Error auto-loading template data', err);
                                        }
                                    }}
                                />
                            )}
                            {createStep === (1 + stepOffset) && (
                                <div className="card shadow-2 border-round-xl p-4 surface-card">
                                    <Step2Signers
                                        documentRecipients={documentRecipients} roleOptions={roleOptions} getCustomerSuggestionsForRow={getCustomerSuggestionsForRow}
                                        searchCustomers={searchCustomers} createCustomer={createCustomer} handleRecipientChange={handleRecipientChange}
                                        addRecipient={addRecipient} removeRecipient={removeRecipient} getRoleOptionsForRow={getRoleOptionsForRow}
                                        isTemplateMode={isCreatingFromTemplate}
                                    />
                                </div>
                            )}
                            {createStep === (2 + stepOffset) && (
                                <Step3Positions
                                    documentRecipients={documentRecipients} signaturePositions={signaturePositions} selectedSigner={selectedSigner}
                                    setSelectedSigner={setSelectedSigner} canvasLoading={canvasLoading} pageCanvases={pageCanvases}
                                    canvasRefs={canvasRefs} draggableRefs={draggableRefs} handleDrop={handleDrop} handleDragStop={handleDragStop}
                                    removeSignaturePosition={(id) => setSignaturePositions(prev => prev.filter(p => p.locationSeqId !== id))}
                                    setSignaturePositions={setSignaturePositions} normalizeLocationSeq={normalizeLocationSeq}
                                    isTemplateMode={isCreatingFromTemplate}
                                    selectedSignatureType={selectedSignatureType}
                                    setSelectedSignatureType={setSelectedSignatureType}
                                    mainFiles={mainFiles}
                                    activeMainFileIndex={activeMainFileIndex}
                                    onSetActiveFile={setActiveMainFileIndex}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </Dialog>

            <TemplateSelectionDialog
                visible={showTemplateDialog}
                onHide={() => setShowTemplateDialog(false)}
                onSelect={handleTemplateSelected}
            />

            <EditorDialog
                display={displayEditor}
                setDisplay={setDisplayEditor}
                agreementId={null}
                setMainFiles={setMainFiles}
            />
            {customerDialog.render()}

            <Dialog
                header="Upload file Excel tài liệu"
                visible={displayBulkUploadDialog}
                style={{ width: '40rem' }}
                position="top"
                draggable={false}
                onHide={() => {
                    setDisplayBulkUploadDialog(false);
                    setSelectedBulkTemplateId(null);
                    setBulkFile(null);
                }}
                footer={(
                    <div className="flex justify-content-end gap-2">
                        <Button
                            label="Tải file mẫu"
                            icon="pi pi-download"
                            className="p-button-outlined p-button-help p-button-sm"
                            type="button"
                            onClick={handleDownloadTemplate}
                            disabled={!selectedBulkTemplateId}
                        />
                        <Button
                            label="Tải lên"
                            icon="pi pi-upload"
                            className="p-button-outlined p-button-success p-button-sm"
                            type="button"
                            loading={isUploadingExcel}
                            onClick={handleSubmitBulkUpload}
                        />
                        <Button
                            label="Đóng"
                            icon="pi pi-times"
                            className="p-button-outlined p-button-secondary p-button-sm"
                            type="button"
                            onClick={() => {
                                setDisplayBulkUploadDialog(false);
                                setBulkFile(null);
                                setSelectedBulkTemplateId(null);
                            }}
                        />
                    </div>
                )}
            >
                <div className="grid">
                    <div className="col-12">
                        <div className="flex flex-column gap-2 mb-3">
                            <label>Chọn biểu mẫu<span style={{ color: 'red' }}>*</span></label>
                            <Dropdown
                                value={selectedBulkTemplateId}
                                options={bulkTemplates}
                                onChange={(e) => setSelectedBulkTemplateId(e.value)}
                                placeholder="Chọn biểu mẫu để tải lên"
                                className="w-full"
                                filter
                                showClear
                            />
                        </div>
                        <div className="flex flex-column gap-2">
                            <label>Chọn file Excel<span style={{ color: 'red' }}>*</span></label>
                            <input
                                className="w-full p-1 border-1 surface-border border-round cursor-pointer"
                                style={{ backgroundColor: 'var(--surface-card)', color: 'var(--text-color)' }}
                                ref={excelInputRef}
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleExcelUpload}
                            />
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog
                header="Kết quả upload Excel tài liệu"
                visible={displayBulkResultDialog}
                style={{ width: '80rem' }}
                position="top"
                onHide={() => { setDisplayBulkResultDialog(false); reloadLazyData(); }}
                footer={(
                    <div className="flex justify-content-end">
                        <Button label="Đóng" icon="pi pi-times" className="p-button-outlined p-button-secondary p-button-sm" type="button" onClick={() => { setDisplayBulkResultDialog(false); reloadLazyData(); }} />
                    </div>
                )}
            >
                <DataTable value={bulkUploadResult} scrollable scrollHeight="400px" dataKey="rowNum" className="p-datatable-sm">
                    <Column field="rowNum" header="STT" style={{ width: '80px' }} />
                    <Column field="agreementNo" header="Số hợp đồng" style={{ width: '150px' }} />
                    <Column field="agreementName" header="Tên tài liệu" />
                    <Column 
                        field="success" 
                        header="Kết quả" 
                        style={{ width: '120px' }} 
                        body={(rowData) => (
                            rowData.success === 'Y' 
                                ? <Tag severity="success" value="Thành công" icon="pi pi-check-circle" />
                                : <Tag severity="danger" value="Thất bại" icon="pi pi-times-circle" />
                        )} 
                    />
                    <Column field="error" header="Ghi chú/Lỗi" body={(rowData) => <div style={{ whiteSpace: 'pre-wrap' }}>{rowData.error}</div>} />
                </DataTable>
            </Dialog>
        </div>
    );
};

const EditorDialog = ({ display, setDisplay, agreementId, setMainFiles }: any) => {
    const [fileId, setFileId] = useState<any>(false);
    const [originalFileId, setOriginalFileId] = useState<string | null>(null);
    const [fileName, setFileName] = useState<string>('');

    useEffect(() => {
        if (display?.fileId) {
            setFileId(display.fileId);
            setOriginalFileId(display.originalFileId || null);
            if (display.fileName) {
                setFileName(display.fileName);
            }
        }
    }, [display]);

    const handleSaveFile = async () => {
        console.log('>>> handleSaveFile (DanhSach - Hybrid Storage):', { fileId, originalFileId, fileName });
        if (!fileId) return;
        if (!fileName || !fileName.trim()) {
            ToastService.error('Vui lòng nhập tên tài liệu');
            return;
        }

        try {
            let res;
            if (originalFileId) {
                console.log('>>> Calling saveEditor (Sync GD to MinIO):', { originalFileId, fileId });
                // Luồng Hybrid Storage: Đồng bộ từ GD về MinIO
                res = await AgreementService.saveEditor(null, originalFileId, fileId);
            } else {
                console.log('>>> Calling syncEditorToMinio (GD -> MinIO):', { fileId, fileName });
                // Luồng mới: Đồng bộ từ GD về MinIO ngay khi tạo mới trên GD
                res = await AgreementService.syncEditorToMinio(fileId, fileName.trim(), display.contentType || 'application/vnd.google-apps.document');
                if (res && res.success === 'Y') {
                    // Cập nhật lại originalFileId bằng ID từ MinIO để các lần lưu sau dùng saveEditor
                    setOriginalFileId(res.fileId);
                }
            }
            console.log('>>> Save result:', res);

            if (res && res.success === 'Y') {
                const finalId = res.fileId || originalFileId || fileId;
                const mappedMain = ({
                    name: fileName.trim(),
                    size: 0,
                    type: extractFileExtension(fileName.trim(), display.contentType || 'docx'),
                    file: undefined,
                    extension: 'docx',
                    googleFileId: finalId,
                    fileId: finalId,
                    id: finalId,
                    googleFileUrl: res.contentLocation || `https://docs.google.com/document/d/${fileId}/edit`,
                    contentLocation: res.contentLocation,
                    referenceFileId: res.referenceFileId || undefined,
                    isMainFile: true
                });
                setMainFiles(prev => [...prev, mappedMain]);
                setTimeout(() => setDisplay(false), 0);
                ToastService.success(`Tài liệu đã được lưu thành công!`);
            } else {
                ToastService.error(res?.error || 'Không thể lưu tài liệu');
            }
        } catch (e: any) {
            ToastService.error('Error saving file');
        }
    }

    return (
        <Dialog
            header="Chỉnh sửa tài liệu"
            visible={!!display}
            style={{ width: '98vw' }}
            position="top"
            onHide={() => setDisplay(false)}
            footer={(
                <div className="flex justify-content-end gap-2">
                    <span className="p-inputgroup" style={{ maxWidth: 360 }}>
                        <span className="p-inputgroup-addon"><i className="pi pi-file" /></span>
                        <InputText value={fileName} onChange={(e) => setFileName(e.target.value)} placeholder="Nhập tên tài liệu" />
                    </span>
                    <Button label="Lưu tài liệu" icon="pi pi-save" type="button" severity="success" size="small" onClick={() => handleSaveFile()} />
                    <Button label="Đóng" icon="pi pi-times" type="button" outlined severity="secondary" size="small" onClick={() => setDisplay(false)} />
                </div>
            )}
        >
            {fileId && (
                <iframe
                    src={`https://docs.google.com/document/d/${fileId}/edit`}
                    width="100%"
                    height="800"
                    style={{ border: 'none' }}
                    referrerPolicy="no-referrer"
                    title="Google Doc Editor"
                ></iframe>
            )}
        </Dialog>
    );
};


